import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Link, useNavigate } from "react-router-dom";
import CountUp from "react-countup";
import { Calendar } from "primereact/calendar";
import type { Nullable } from "primereact/ts-helpers";
import "bootstrap-daterangepicker/daterangepicker.css";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { all_routes } from "../../router/all_routes";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AdminDashboardModal from "./adminDashboardModal";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../UserPermissionsContext";
import { ApexOptions } from "apexcharts";
import { DatePicker, Select, Spin } from "antd";
import { set } from "date-fns";
import CircleProgress from "../studentDashboard/circleProgress";
import LogoSpinnerInline from "../../academic/examinations/spinner";
import { InactivityContext } from "../../academic/examinations/InactivityContext";
import React from "react";
import { BiRefresh } from "react-icons/bi";
import Counter from "../../academic/examinations/counter";
import { motion, Variants } from "framer-motion";
import Leaderboard from "./leaderboard";
import LeaderboardStage from "./leaderboard";
import card from "antd/es/card";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import dayjs from "dayjs";
type FilterType = "overall" | "today" | "week" | "month";
type CardsApiResponse = any;
interface Cards {
  id: number;
  heading: string;
  type: number;
  type_name: string;
  section: number;
  section_name: string;
  logo: string;
  sequence: number;
  heading_value: string;
  sub_heading_1: string;
  sub_heading_1_value: string;
  sub_heading_2: string;
  sub_heading_2_value: string;
  percentage: string;
}

type CardItem = {
  id: string;
  logo: string;
  heading: string;
  heading_value: number;
  percentage: number;
  sub_heading_1: string;
  sub_heading_1_value: number;
  sub_heading_2: string;
  sub_heading_2_value: number;
};

interface overallCards {
  calls: {
    total_calls: number;
    connected_calls: number;
    missed_calls: number;
    calls_per: number;
  };
  students: {
    total_students: number;
    connected_students: number;
    remaining_students: number;
    students_per: number;
  };
  tickets: {
    total_tickets: number;
    interested_tickets: number;
    remaining_tickets: number;
    tickets_per: number;
  };
  sales: {
    total_sales: number;
    on_call_sales: number;
    branch_sales: number;
    targeted_sales: number;
    sales_per: number;
    renewals_sales: number;
    new_sales: number;
  };
}
interface QuickLinks {
  id: number;
  name: string;
  type: number;
  type_name: string;
  logo: string;
  front_end_url: string;
  bg_color: string;
  sequence: number;
}

interface Sales {
  label: string;
  sales: number;
  target: number;
  new_sales: number;
  renewals: number;
}

interface WeeklyConversationOfAgent {
  label: string;
  actual: number;
  target: number;
}


interface TopThree {
  agent_id: number;
  agent_name: string;
  sales_count: number;
  agent_profile: string;
}

type SalesRank = {
  total_sales: number;
  branch_count: number;
  branches: User1[];
};


type User1 = {
  branch_id: number;
  branch: string;
  sales: number;
};

interface SortConfig {
  field: "sales" | "strength";
  direction: "asc" | "desc";
  secondaryDirection: "asc" | "desc"; // New state to track secondary direction
}
interface BranchSalesRanking {
  id: number;
  branch: number;
  branch_name: string;
  sales: number;
  strength: number;
  sale_rank_group_name: string;
  sale_rank_group: number;
}

interface BranchSalesRankingGroup {
  sale_rank_group: number;
  sale_rank_group_name: string;
  branch_wise_sale_details: BranchSalesRanking[];
}


interface TeamsRankingMembers {
  id: number;
  username: string;
  no_of_sales: number;
}

interface TeamsRankingGroup {
  sales_rank_group: number;
  sales_rank_group_name: string;
  total_sales: number;
  members: TeamsRankingMembers[];
}

interface FollowUpRow {
  period: string;
  total_sales: number;
  followup_sales: number;
  percentage: number;
}

interface FollowUpSalesState {
  columns: string[];
  rows: FollowUpRow[];
}

interface BranchClasses {
  class_id: number;
  class_name: string;
  strength: number;
  total_sales: number;
}

interface BranchClassesRenewal {
  class_id: number;
  class_name: string;
  last_year_sales: number;
  renewal_sales: number;
}


interface BranchClassWise {
  branch_id: number;
  branch_name: string;
  class_wise_sales: BranchClasses[];
}

interface BranchClassWiseRenewal {
  branch_id: number;
  branch_name: string;
  class_wise_sales: BranchClassesRenewal[];
}

interface AttendanceDataForAdmin {
  no_of_present_agents: number;
  no_of_absent_agents: number;
  date: string;
  total_agents: number;
  is_admin: boolean;
}

interface AttendanceDataForAgent {
  no_of_present_days: number;
  no_of_absent_days: number;
  date: string;
  total_days: number;
  is_admin: boolean;
}

interface PerformanceData {
  date: string;
  achieved: number;
  target: number;
  renewals: number;
  new_sales: number;
  is_admin: boolean;
}

interface CallBacks {
  date: string;
  total_call_backs: number;
  morning_call_backs: number;
  afternoon_call_backs: number;
  evening_call_backs: number;
}

type PhotoType = {
  photo: string;
};

type Dashboard = {
  id: number;
  agent_name: string;
  status_name: string;
  updated_at: string;
  last_login_time: string;
  agent: number;
  status: number;
  calls: string;
  connected: string;
  missed: string;
  interested: string;
  callbacks: string;
  sale: string;
  performance: string;
  total_ideal_time: string;
  profile_pic: string;
};

type MonthlySales = {
  label: string;
  sales: number;
  target: number;
}

type RevenueAndSalesStats = {
  target_revenue: string;
  achieved_revenue: string;
  revenue_growth_percentage: string;
  target_sales: string;
  achieved_sales: string;
  sales_growth_percentage: string;
}
type Agent = {
  id: number;
  name: string;
  sales: number;
  avatar: string;
};

const generateAgents = (count: number): Agent[] => {
  return Array.from({ length: count }, (_, i) => ({
    id: i + 1,
    name: `Agent ${i + 1}`,
    sales: Math.floor(Math.random() * 1000),
    avatar: `https://i.pravatar.cc/100?img=${(i % 70) + 1}`,
  }));
};

const AdminDashboard1 = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const [cards, setCards] = useState<Cards[]>([]);
  const [overallCards, setOverallCards] = useState<overallCards | null>(null);
  const [todayCards, setTodayCards] = useState<overallCards | null>(null);
  const [weekCards, setWeekCards] = useState<overallCards | null>(null);
  const [monthCards, setMonthCards] = useState<overallCards | null>(null);
  const [filter, setFilter] = useState<FilterType>("overall");
  // const todayCardsData = todayCards
  //   ? [
  //     {
  //       id: "students",
  //       logo: "/assets/img/students_2995620.png",
  //       heading: "Students",
  //       heading_value: todayCards.students.total_students,
  //       percentage: todayCards.students.students_per,
  //       sub_heading_1: "Connected",
  //       sub_heading_1_value: todayCards.students.connected_students,
  //       sub_heading_2: "Remaining",
  //       sub_heading_2_value: todayCards.students.remaining_students,
  //     },
  //     {
  //       id: "calls",
  //       logo: "/assets/img/phone-call_1759915.png",
  //       heading: "Calls",
  //       heading_value: todayCards.calls.total_calls,
  //       percentage: todayCards.calls.calls_per,
  //       sub_heading_1: "Connected",
  //       sub_heading_1_value: todayCards.calls.connected_calls,
  //       sub_heading_2: "Missed",
  //       sub_heading_2_value: todayCards.calls.missed_calls,
  //     },
  //     {
  //       id: "tickets",
  //       logo: "/assets/img/travel_14898221.png",
  //       heading: "Tickets",
  //       heading_value: todayCards.tickets.total_tickets,
  //       percentage: todayCards.tickets.tickets_per,
  //       sub_heading_1: "Interested",
  //       sub_heading_1_value: todayCards.tickets.interested_tickets,
  //       sub_heading_2: "Remaining",
  //       sub_heading_2_value: todayCards.tickets.remaining_tickets,
  //     },
  //     {
  //       id: "sales",
  //       logo: "/favicon.png",
  //       heading: "Sales",
  //       heading_value: todayCards.sales.total_sales,
  //       percentage: todayCards.sales.sales_per,
  //       sub_heading_1: "New Sales",
  //       sub_heading_1_value: todayCards.sales.new_sales,
  //       sub_heading_2: "Renewals",
  //       sub_heading_2_value: todayCards.sales.renewals_sales,
  //     },
  //   ]
  //   : [];
  // const weekCardsData = weekCards
  //   ? [
  //     {
  //       id: "students",
  //       logo: "/assets/img/students_2995620.png",
  //       heading: "Students",
  //       heading_value: weekCards.students.total_students,
  //       percentage: weekCards.students.students_per,
  //       sub_heading_1: "Connected",
  //       sub_heading_1_value: weekCards.students.connected_students,
  //       sub_heading_2: "Remaining",
  //       sub_heading_2_value: weekCards.students.remaining_students,
  //     },
  //     {
  //       id: "calls",
  //       logo: "/assets/img/phone-call_1759915.png",
  //       heading: "Calls",
  //       heading_value: weekCards.calls.total_calls,
  //       percentage: weekCards.calls.calls_per,
  //       sub_heading_1: "Connected",
  //       sub_heading_1_value: weekCards.calls.connected_calls,
  //       sub_heading_2: "Missed",
  //       sub_heading_2_value: weekCards.calls.missed_calls,
  //     },
  //     {
  //       id: "tickets",
  //       logo: "/assets/img/travel_14898221.png",
  //       heading: "Tickets",
  //       heading_value: weekCards.tickets.total_tickets,
  //       percentage: weekCards.tickets.tickets_per,
  //       sub_heading_1: "Interested",
  //       sub_heading_1_value: weekCards.tickets.interested_tickets,
  //       sub_heading_2: "Remaining",
  //       sub_heading_2_value: weekCards.tickets.remaining_tickets,
  //     },
  //     {
  //       id: "sales",
  //       logo: "/favicon.png",
  //       heading: "Sales",
  //       heading_value: weekCards.sales.total_sales,
  //       percentage: weekCards.sales.sales_per,
  //       sub_heading_1: "New Sales",
  //       sub_heading_1_value: weekCards.sales.new_sales,
  //       sub_heading_2: "Renewals",

  //       sub_heading_2_value: weekCards.sales.renewals_sales,
  //     },
  //   ]
  //   : [];
  // const monthCardsData = monthCards
  //   ? [
  //     {
  //       id: "students",
  //       logo: "/assets/img/students_2995620.png",
  //       heading: "Students",
  //       heading_value: monthCards.students.total_students,
  //       percentage: monthCards.students.students_per,
  //       sub_heading_1: "Connected",
  //       sub_heading_1_value: monthCards.students.connected_students,
  //       sub_heading_2: "Remaining",
  //       sub_heading_2_value: monthCards.students.remaining_students,
  //     },
  //     {
  //       id: "calls",
  //       logo: "/assets/img/phone-call_1759915.png",
  //       heading: "Calls",
  //       heading_value: monthCards.calls.total_calls,
  //       percentage: monthCards.calls.calls_per,
  //       sub_heading_1: "Connected",
  //       sub_heading_1_value: monthCards.calls.connected_calls,
  //       sub_heading_2: "Missed",
  //       sub_heading_2_value: monthCards.calls.missed_calls,
  //     },
  //     {
  //       id: "tickets",

  //       logo: "/assets/img/travel_14898221.png",
  //       heading: "Tickets",
  //       heading_value: monthCards.tickets.total_tickets,
  //       percentage: monthCards.tickets.tickets_per,
  //       sub_heading_1: "Interested",
  //       sub_heading_1_value: monthCards.tickets.interested_tickets,
  //       sub_heading_2: "Remaining",
  //       sub_heading_2_value: monthCards.tickets.remaining_tickets,
  //     },
  //     {
  //       id: "sales",
  //       logo: "/favicon.png",
  //       heading: "Sales",
  //       heading_value: monthCards.sales.total_sales,
  //       percentage: monthCards.sales.sales_per,
  //       sub_heading_1: "New Sales",
  //       sub_heading_1_value: monthCards.sales.new_sales,
  //       sub_heading_2: "Renewals",
  //       sub_heading_2_value: monthCards.sales.renewals_sales,
  //     },
  //   ]
  //   : [];
  // const cardsData = overallCards
  //   ? [
  //     {
  //       id: "students",
  //       logo: "/assets/img/students_2995620.png",
  //       heading: "Students",
  //       heading_value: overallCards.students.total_students,
  //       percentage: overallCards.students.students_per,
  //       sub_heading_1: "Connected",
  //       sub_heading_1_value: overallCards.students.connected_students,
  //       sub_heading_2: "Remaining",
  //       sub_heading_2_value: overallCards.students.remaining_students,
  //     },
  //     {
  //       id: "calls",
  //       logo: "/assets/img/phone-call_1759915.png",
  //       heading: "Calls",
  //       heading_value: overallCards.calls.total_calls,
  //       percentage: overallCards.calls.calls_per,
  //       sub_heading_1: "Connected",
  //       sub_heading_1_value: overallCards.calls.connected_calls,
  //       sub_heading_2: "Missed",
  //       sub_heading_2_value: overallCards.calls.missed_calls,
  //     },

  //     {
  //       id: "tickets",
  //       logo: "/assets/img/travel_14898221.png",
  //       heading: "Tickets",
  //       heading_value: overallCards.tickets.total_tickets,
  //       percentage: overallCards.tickets.tickets_per,
  //       sub_heading_1: "Interested",
  //       sub_heading_1_value: overallCards.tickets.interested_tickets,
  //       sub_heading_2: "Remaining",
  //       sub_heading_2_value: overallCards.tickets.remaining_tickets,
  //     },
  //     {
  //       id: "sales",
  //       logo: "/favicon.png",
  //       heading: "Sales",
  //       heading_value: overallCards.sales.total_sales,
  //       percentage: overallCards.sales.sales_per,
  //       sub_heading_1: "New Sales",
  //       sub_heading_1_value: overallCards.sales.new_sales,
  //       sub_heading_2: "Renewals",
  //       sub_heading_2_value: overallCards.sales.renewals_sales,
  //     },
  //   ]
  //   : [];
  const formatCardsData = (data: any): CardItem[] => {
    if (!data) return [];

    return [
      {
        id: "students",
        logo: "/assets/img/students_2995620.png",
        heading: "Students",
        heading_value: data?.students?.total_students ?? 0,
        percentage: data?.students?.students_per ?? 0,
        sub_heading_1: "Connected",
        sub_heading_1_value: data?.students?.connected_students ?? 0,
        sub_heading_2: "Remaining",
        sub_heading_2_value: data?.students?.remaining_students ?? 0,
      },
      {
        id: "calls",
        logo: "/assets/img/phone-call_1759915.png",
        heading: "Calls",
        heading_value: data?.calls?.total_calls ?? 0,
        percentage: data?.calls?.calls_per ?? 0,
        sub_heading_1: "Connected",
        sub_heading_1_value: data?.calls?.connected_calls ?? 0,
        sub_heading_2: "Missed",
        sub_heading_2_value: data?.calls?.missed_calls ?? 0,
      },
      {
        id: "tickets",
        logo: "/assets/img/travel_14898221.png",
        heading: "Tickets",
        heading_value: data?.tickets?.total_tickets ?? 0,
        percentage: data?.tickets?.tickets_per ?? 0,
        sub_heading_1: "Interested",
        sub_heading_1_value: data?.tickets?.interested_tickets ?? 0,
        sub_heading_2: "Remaining",
        sub_heading_2_value: data?.tickets?.remaining_tickets ?? 0,
      },
      {
        id: "sales",
        logo: "/favicon.png",
        heading: "Sales",
        heading_value: data?.sales?.total_sales ?? 0,
        percentage: data?.sales?.sales_per ?? 0,
        sub_heading_1: "New Sales",
        sub_heading_1_value: data?.sales?.new_sales ?? 0,
        sub_heading_2: "Renewals",
        sub_heading_2_value: data?.sales?.renewals_sales ?? 0,
      },
    ];
  };
  const [quickLinks, setQuickLinks] = useState<QuickLinks[]>([]);
  const [sales, setSales] = useState<Sales[]>([]);
  const [salesAdmin, setSalesAdmin] = useState<boolean>(false);
  const [chartData, setChartData] = useState<any>(null);
  const [weeklyConversationOfAgent, setWeeklyConversationOfAgent] = useState<WeeklyConversationOfAgent[]>([]);
  const { userPermissions, webApi, userData } = useUserPermissions();
  const [overallTopThree, setOverallTopThree] = useState<TopThree[]>([])
  const [todayTopThree, setTodayTopThree] = useState<TopThree[]>([]);
  const [salesRank, setSalesRank] =
    useState<BranchSalesRankingGroup | null>(null);
  const [teamRank, setTeamRank] = useState<TeamsRankingGroup | null>(null);
  const [followUpSales, setFollowUpSales] = useState<FollowUpSalesState>({
    columns: ["total_sales", "followup_sales", "percentage"],
    rows: []
  });
  const [currrentYearBranchClassWise, setCurrentYearBranchClassWise] = useState<BranchClassWise | null>(null);
  const [lastYearBranchClassWise, setLastYearBranchClassWise] = useState<BranchClassWiseRenewal | null>(null);
  const [attendanceDataForAdmin, setAttendanceDataForAdmin] = useState<AttendanceDataForAdmin | null>(null);
  const [attendanceDataForAgent, setAttendanceDataForAgent] = useState<AttendanceDataForAgent | null>(null);
  const [revenueAndSalesStats, setRevenueAndSalesStats] = useState<RevenueAndSalesStats | null>(null);
  const [callBacks, setCallBacks] = useState<CallBacks | null>(null);
  const context = useContext(InactivityContext);
  if (!context) {
    throw new Error("SomeComponent must be used within an InactivityProvider");
  }
  const { setIsStatusChange } = context;
  const [performanceData, setPerformanceData] = useState<PerformanceData | null>(null);
  const [selectedGroup, setSelectedGroup] = useState<number | null>(null);
  const [selectedZone, setSelectedZone] = useState<number | null>(null);
  const [selectedTeamGroup, setSelectedTeamGroup] = useState<number | null>(null);
  const [selectedCurrentYearBranch, setSelectedCurrentYearBranch] = useState<number | null>(null);
  const [selectedLastYearBranch, setSelectedLastYearBranch] = useState<number | null>(null);
  const [selectedAttendanceDate, setSelectedAttendanceDate] = useState<string | null>(null);
  const [selectedPerformanceDateRange, setSelectedPerformanceDateRange] = useState<string | null>(null);
  const [selectedPerformanceAgent, setSelectedPerformanceAgent] = useState<number | null>(null);
  const [selectedCallBackDate, setSelectedCallBackDate] = useState<Date | null>(null);
  const [rankGroups, setRankGroups] = useState<Array<{ id: number; name: string }>>([]);
  const [teamRankGroups, setTeamRankGroups] = useState<Array<{ id: number; name: string }>>([]);
  const [branchDropDropwn, setBranchDropDown] = useState<Array<{ branch_id: number; name: string }>>([]);
  const [performanceAgents, setPerformanceAgents] = useState<Array<{ id: number; username: string }>>([]);
  const [zones, setZones] = useState<Array<{ zone_id: number; name: string }>>([]);
  const [salesRankDropdown, setSalesRankDropdown] = useState(false);
  const [SalesRankLoading, setSalesRankLoading] = useState(false);
  const [teamRankLoading, setTeamRankLoading] = useState(false);
  const [currentYearBranchTableLoading, setCurrentYearBranchTableLoading] = useState(false);
  const [attendanceTableLoading, setAttendanceTableLoading] = useState(false);
  const [performanceTableLoading, setPerformanceTableLoading] = useState(false);
  const [lastYearBranchTableLoading, setLastYearBranchTableLoading] = useState(false);
  const [callBacksLoading, setCallBacksLoading] = useState(false);
  const [rankGroupSearch, setRankGroupSearch] = useState("");
  // const [photo1, setPhoto1] = useState<PhotoType>({ photo: "" });
  const [selectedStatus, setSelectedStatus] = useState<string | undefined>(undefined);
  const [dashboardData, setDashboardData] = useState<Dashboard[]>([]);
  const [selectedAgents, setSelectedAgents] = useState<number[]>([]);
  const [refreshIsLoading, seteRfreshIsLoading] = useState(false);
  const [cardLoading, setCardLoading] = useState(false);
  const [todayCardLoading, setTodayCardLoading] = useState(false);
  const [weekCardLoading, setWeekCardLoading] = useState(false);
  const [monthCardLoading, setMonthCardLoading] = useState(false);
  const [weeklyConversationOfAgentLoading, setWeeklyConversationOfAgentLoading] = useState(false);
  const [revenueAndSalesStatsLoading, setRevenueAndSalesStatsLoading] = useState(false);
  const [weeklySalesOfAgentLoading, setWeeklySalesOfAgentLoading] = useState(false);
  const [followUpSalesLoading, setFollowUpSalesLoading] = useState(false);
  const [photoLoading, setPhotoLoading] = useState(false);
  const [salesStats, setSalesStats] = useState<any>(null);
  const [revenueStats, setRevenueStats] = useState<any>(null);
  const [monthlySales, setMonthlySales] = useState<MonthlySales[]>([]);
  const [monthlySalesLoading, setMonthlySalesLoading] = useState(false);
  const [salesStatsLoading, setSalesStatsLoading] = useState(false);
  const [revenueStatsLoading, setRevenueStatsLoading] = useState(false);
  const [animate, setAnimate] = useState(false);
  const [selectedType, setSelectedType] = useState<string>("New");
  const agents = useMemo(() => generateAgents(50), []);
  const [attendanceList, setAttendanceList] = useState<any[]>([]);
  const [attendanceLoading, setAttendanceLoading] = useState(false);
  const [selectedAttendanceType, setSelectedAttendanceType] = useState<'present' | 'absent'>('present');
  // const [selectedCardsType, setSelectedCardsType] = useState<"overall" | "today" | "week" | "month">("overall");
  const [loading, setLoading] = useState(false);
  const ranked = [...agents].sort((a, b) => b.sales - a.sales);
  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate((prev) => !prev);
    }, 1200);
    return () => clearInterval(interval);
  }, []);
  const [monitoringStatus, setMonitoringStatus] = useState<
    { id: number; name: string }[]
  >([]);
  const [bgGradient, setBgGradient] = React.useState(
    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
  );

  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const extractColor = (img: HTMLImageElement) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    ctx.drawImage(img, 0, 0);

    const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);

    let r = 0, g = 0, b = 0, count = 0;

    for (let i = 0; i < data.length; i += 4 * 20) {
      r += data[i];
      g += data[i + 1];
      b += data[i + 2];
      count++;
    }

    r = Math.floor(r / count);
    g = Math.floor(g / count);
    b = Math.floor(b / count);

    setBgGradient(
      `linear-gradient(135deg, rgb(${r},${g},${b}) 0%, rgba(${r},${g},${b},0.6) 100%)`
    );
  };



  const inactivityContext = useContext(InactivityContext);
  if (!inactivityContext) {
    throw new Error("Header must be used within an InactivityProvider");
  }
  const { photo1 } = inactivityContext;
  // const target = performanceData?.target ?? 0;
  // const achieved = performanceData?.achieved ?? 0;
  // const series: number[] = [
  //   achieved,
  //   Math.max(target - achieved, 0), // remaining
  // ];

  const performanceAdmin = performanceData?.is_admin;

  const target = performanceData?.target ?? 0;
  const achieved = performanceData?.achieved ?? 0;
  const renewals = performanceData?.renewals ?? 0;
  const newSales = performanceData?.new_sales ?? 0;

  let remaining = 0;

  if (performanceAdmin) {
    if (selectedType === "New") {
      remaining = Math.max(target - newSales, 0);
    } else if (selectedType === "Renewals") {
      remaining = Math.max(target - renewals, 0);
    } else {
      // default (overall)
      remaining = Math.max(target - achieved, 0);
    }
  } else {
    remaining = Math.max(target - achieved, 0);
  }

  let series: number[] = [];

  if (performanceAdmin) {
    if (selectedType === "New") {
      series = [newSales, remaining];
    } else if (selectedType === "Renewals") {
      series = [renewals, remaining];
    } else {
      // default (no filter)
      series = [newSales, renewals, remaining];
    }
  } else {
    series = [achieved, remaining];
  }

  const total = callBacks?.total_call_backs ?? 0;
  const morning = callBacks?.morning_call_backs ?? 0;
  const afternoon = callBacks?.afternoon_call_backs ?? 0;
  const evening = callBacks?.evening_call_backs ?? 0;
  const percent = (value: number) =>
    total ? Math.round((value / total) * 100) : 0;

  const isAdmin = attendanceDataForAdmin?.is_admin;

  const cardVariants: Variants = {
    hidden: {
      opacity: 0,
      y: 30,
    },
    visible: (index: number) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: index * 0.1,
        duration: 0.5,
        ease: [0.25, 0.1, 0.25, 1], // ← cubic-bezier (easeOut)
      },
    }),
  };

  const handleSortClick = (clickedField: "sales" | "strength") => {
    setSortConfig((prev) => {
      if (prev.field === clickedField) {
        // Flip direction if same field
        return {
          ...prev,
          direction: prev.direction === "asc" ? "desc" : "asc",
        };
      } else {
        // New field - maintain the other field's direction as secondary
        return {
          field: clickedField,
          direction: "asc", // Default direction for new primary field
          secondaryDirection: prev.direction, // Preserve the previous primary direction
        };
      }
    });
  };
  const [sortConfig, setSortConfig] = useState<SortConfig>({
    field: "sales",
    direction: "desc",
    secondaryDirection: "desc",
  });
  const sortedQuickLinks = [...quickLinks].sort(
    (a, b) => a.sequence - b.sequence
  );
  const jwtToken = Cookies.get("authToken");
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const statistic_chart = {
    chart: {
      type: "line",
      height: 345,
    },
    series: [
      {
        name: "Current Year",
        data: salesStats?.current_year || [],
      },
      {
        name: "Previous Year",
        data: salesStats?.previous_year || [],
      },
    ],
    xaxis: {
      categories: salesStats?.categories || [],
    },
    tooltip: {
      shared: true,
      intersect: false,
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#3D5EE1", "#6FCCD8"],
    legend: {
      position: "top",
      horizontalAlign: "left",
    },
  };

  const Revenue_chart: ApexOptions = useMemo(() => ({
    chart: {
      type: "line",
      height: 345,
    },

    series: [
      {
        name: "Current Year Revenue",
        data: revenueStats?.current_year_revenue ?? [],
      },
      {
        name: "Previous Year Revenue",
        data: revenueStats?.previous_year_revenue ?? [],
      },
    ],

    xaxis: {
      categories: revenueStats?.categories ?? [],
    },

    tooltip: {
      enabled: true,
      shared: true,
      intersect: false,
      followCursor: true,
      y: {
        formatter: (value: number) => {
          if (value >= 10000000) {
            return (value / 10000000).toFixed(1) + " Cr";
          } else if (value >= 100000) {
            return (value / 100000).toFixed(1) + " L";
          } else if (value >= 1000) {
            return (value / 1000).toFixed(1) + " K";
          }
          return value.toString();
        },
      },
    },

    dataLabels: {
      enabled: false,
    },

    grid: {
      yaxis: {
        lines: {
          show: true,
        },
      },
      padding: {
        left: -8,
      },
    },

    yaxis: {
      labels: {
        offsetX: -15,
        formatter: (value: number) => {
          if (value >= 10000000) {
            return (value / 10000000).toFixed(1) + "Cr";
          } else if (value >= 100000) {
            return (value / 100000).toFixed(1) + "L";
          } else if (value >= 1000) {
            return (value / 1000).toFixed(1) + "K";
          }
          return value.toString();
        },
      },
    },

    markers: {
      size: 0,
      colors: ["#1E90FF", "#00BFFF"],
      strokeColors: "#fff",
      strokeWidth: 1,
      hover: {
        size: 7,
      },
    },

    colors: ["#3D5EE1", "#6FCCD8"],

    legend: {
      position: "top",
      horizontalAlign: "left",
    },
  }), [revenueStats]);

  const Sales_chart: ApexOptions = useMemo(() => ({
    chart: {
      type: "line",
      height: 345,
    },

    series: [
      {
        name: "Current Year",
        data: salesStats?.current_year ?? [],
      },
      {
        name: "Previous Year",
        data: salesStats?.previous_year ?? [],
      },
    ],

    xaxis: {
      categories: salesStats?.categories ?? [],
    },

    tooltip: {
      enabled: true,
      shared: true,
      intersect: false,
      followCursor: true,
      y: {
        formatter: (val: number) =>
          val.toLocaleString('en-IN'),
      },
    },

    dataLabels: {
      enabled: false,
    },

    grid: {
      yaxis: {
        lines: {
          show: true,
        },
      },
      padding: {
        left: -8,
      },
    },

    yaxis: {
      labels: {
        offsetX: -15,
      },
    },

    markers: {
      size: 0,
      colors: ["#1E90FF", "#00BFFF"],
      strokeColors: "#fff",
      strokeWidth: 1,
      hover: {
        size: 7,
      },
    },

    colors: ["#3D5EE1", "#6FCCD8"],

    legend: {
      position: "top",
      horizontalAlign: "left",
    },
  }), [salesStats]);



  useEffect(() => {
    // fetchOverallCards();
    // fetchTodayCards();
    // fetchWeekCards();
    // fetchMonthCards();
    fetchQuickLinks();
    fetchSales();
    fetchOverallTopThree();
    fetchTodayTopThree();
    fetchRankGroups();
    fetchSalesRank();
    fetchTeamRankGroups();
    fetchTeamRank();
    fetchBranches();
    fetchCurrentYearBranchClassWise();
    fetchLastYearBranchClassWise();
    fetchAttendanceData();
    fetchPerformanceData();
    fetchAgents();
    fetchCallBacksData();
    fetchMonitoringStatusDropdown();
    fetchData();
    fetchConversationOfAgent();
    fetchSalesStats();
    fetchRevenueStats();
    fetchMonthlySales();
    fetchRevenueAndSalesStats();
    fetchZones();
    fetchFollowUpSales();
  }, []);

  //   useEffect(() => {
  //   // call once immediately
  //   fetchData();

  //   // repeat every 1 minute
  //   const interval = setInterval(fetchData, 60000);

  //   // cleanup when component unmounts
  //   return () => clearInterval(interval);
  // }, []);

  useEffect(() => {
    fetchPerformanceData();
  }, [selectedPerformanceDateRange, selectedPerformanceAgent, selectedType]);
  useEffect(() => {
    if (selectedCurrentYearBranch !== null) {
      fetchCurrentYearBranchClassWise();
      fetchLastYearBranchClassWise();
    }
  }, [selectedCurrentYearBranch]);

  // useEffect(() => {
  //   if (selectedLastYearBranch !== null) {

  //   }
  // }, [selectedLastYearBranch]);

  useEffect(() => {
    fetchAttendanceData();
  }, [selectedAttendanceDate]);

  useEffect(() => {
    if (selectedGroup !== null) {
      fetchSalesRank();
      if (selectedZone !== null) {
        fetchSalesRank();
      }
    }
  }, [selectedGroup, selectedZone]);


  useEffect(() => {
    if (selectedTeamGroup !== null) {
      fetchTeamRank();
    }
  }, [selectedTeamGroup]);

  useEffect(() => {

    fetchCallBacksData();
  }, [selectedCallBackDate]);
  // useEffect(() => {
  //   const fetchPhoto = async () => {
  //     setPhotoLoading(true);

  //     try {
  //       const response = await fetch(
  //         `${webApi}/user/add_update_userprofile_by_user/`,
  //         options
  //       );

  //       if (!response.ok) {
  //         const errorData = await response.json();

  //         if (errorData.code === "token_not_valid") {
  //           navigate("/login");
  //           return;
  //         }

  //         throw new Error(errorData.detail || "Failed to fetch user data");
  //       }

  //       const data = await response.json();
  //       setPhoto1(data.data);
  //     } catch (error) {
  //       console.error("Photo fetch failed:", error);
  //     } finally {
  //       setPhotoLoading(false);
  //     }
  //   };

  //   fetchPhoto();
  // }, [isProfileChange]);

  const handlePresentClick = () => {
    setSelectedAttendanceType('present');
    fetchAttendanceList(true);
  };

  const handleAbsentClick = () => {
    setSelectedAttendanceType('absent');
    fetchAttendanceList(false);
  };

  const fetchAttendanceList = async (isPresent: boolean) => {
    setAttendanceLoading(true);

    try {
      const params = new URLSearchParams();

      if (selectedAttendanceDate) {
        params.append('date', selectedAttendanceDate);
      }
      params.append('page_size', "100");

      // ✅ ALWAYS send is_present (since click decides it)
      params.append('is_present', String(isPresent));

      const apiUrl = `${webApi}/user/agent_attendance/?${params.toString()}`;

      const response = await fetch(apiUrl, options);
      const data = await response.json();

      setAttendanceList(data.results || []);
    } catch (err) {
      console.error(err);
    } finally {
      setAttendanceLoading(false);
    }
  };

  const handleExportClick = async () => {

    let apiUrl = `${webApi}/new_dashboards/export_branch_sales_dashboard/?token=${jwtToken}`;
    if (selectedGroup !== null) {
      apiUrl += `&sale_rank_group=${selectedGroup}`;
    }
    if (selectedZone !== null) {
      apiUrl += `&branch__zone=${selectedZone}`;
    }

    window.location.href = apiUrl

  };

  const fetchRevenueAndSalesStats = async () => {
    setRevenueAndSalesStatsLoading(true); // Set loading to true
    try {
      const response = await fetch(
        `${webApi}/new_dashboards/wizklub_revenue_data/`,
        options
      );
      const data = await response.json();
      setRevenueAndSalesStats(data);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setRevenueAndSalesStatsLoading(false); // Set loading back to false after fetch is complete
    }
  };

  const fetchFollowUpSales = async () => {
    setFollowUpSalesLoading(true);

    try {
      const response = await fetch(
        `${webApi}/wizklub/wizklub_followupsales_details/`,
        options
      );

      const apiData = await response.json();
      const rawData = apiData.data || {};

      // Dynamic columns from API
      const columns = Object.keys(
        Object.values(rawData)[0] || {}
      );

      // Transform rows
      const transformedRows = Object.entries(rawData).map(
        ([periodKey, values]: [string, any]) => {
          let displayPeriod = periodKey;

          if (periodKey === "48days") {
            displayPeriod = "48 Days";
          } else {
            displayPeriod =
              periodKey.charAt(0).toUpperCase() +
              periodKey.slice(1);
          }

          return {
            period: displayPeriod,
            ...values,
          };
        }
      );

      setFollowUpSales({
        columns,
        rows: transformedRows,
      });
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setFollowUpSalesLoading(false);
    }
  };

  const fetchZones = async () => {
    // setRevenueAndSalesStatsLoading(true); // Set loading to true
    try {
      const response = await fetch(
        `${webApi}/branches/zone_dropdown_for_branch_sale_ranking_dashboard/`,
        options
      );
      const data = await response.json();
      setZones(data);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      // setRevenueAndSalesStatsLoading(false); // Set loading back to false after fetch is complete
    }
  };

  const fetchMonthlySales = async () => {
    setMonthlySalesLoading(true); // Set loading to true
    try {
      const response = await fetch(
        `${webApi}/new_dashboards/monthly_sales_graph/`,
        options
      );
      const data = await response.json();
      setMonthlySales(data.data);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setMonthlySalesLoading(false); // Set loading back to false after fetch is complete
    }
  };

  const fetchRevenueStats = async () => {
    setRevenueStatsLoading(true); // Set loading to true
    try {
      const response = await fetch(
        `${webApi}/new_dashboards/monthly_revenue_comparison_graph/`,
        options
      );
      const data = await response.json();
      setRevenueStats(data);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setRevenueStatsLoading(false); // Set loading back to false after fetch is complete
    }
  };

  const fetchSalesStats = async () => {
    setSalesStatsLoading(true); // Set loading to true
    try {
      const response = await fetch(
        `${webApi}/new_dashboards/monthly_sales_count_comparison_graph/`,
        options
      );
      const data = await response.json();
      setSalesStats(data);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setSalesStatsLoading(false); // Set loading back to false after fetch is complete
    }
  };

  const fetchData = async () => {
    seteRfreshIsLoading(true); // Set loading to true
    try {
      const response = await fetch(
        `${webApi}/dashboard/wizklub_agent_monitoring/`,
        options
      );
      const data = await response.json();
      setDashboardData(data.results);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      seteRfreshIsLoading(false); // Set loading back to false after fetch is complete
    }
  };

  const fetchConversationOfAgent = async () => {
    setWeeklyConversationOfAgentLoading(true); // Set loading to true
    try {
      const response = await fetch(
        `${webApi}/new_dashboards/wizklub_conversation_time_graph_dashboard/`,
        options
      );
      const data = await response.json();
      setWeeklyConversationOfAgent(data);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setWeeklyConversationOfAgentLoading(false); // Set loading back to false after fetch is complete
    }
  };


  const fetchAgents = async () => {
    try {
      const response = await fetch(
        `${webApi}/teammgmt/get_team_members_by_teammgmt/2/`,
        options
      );

      if (!response.ok) throw new Error("Failed to fetch agents");
      const data = await response.json();
      setPerformanceAgents(data);
    } catch (error) {
      console.error("Error fetching agents:", error);
    }
  };

  const fetchMonitoringStatusDropdown = async () => {
    const response = await fetch(
      `${webApi}/user_monitoring/monitoring_status_types_dropdown/`,
      options
    );
    const data = await response.json();
    setMonitoringStatus(data);
  };

  const fetchBranches = async () => {
    try {
      const response = await fetch(
        `${webApi}/branches/wizklub_branches_dropdown/`,
        options
      );

      if (!response.ok) throw new Error("Failed to fetch branches");
      const data = await response.json();
      setBranchDropDown(data);
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };

  const fetchRankGroups = async () => {
    try {
      const response = await fetch(
        `${webApi}/new_dashboards/branch_sales_rank_group_dropdown/`,
        options
      );

      if (!response.ok) throw new Error("Failed to fetch rank groups");
      const data = await response.json();
      setRankGroups(data);
    } catch (error) {
      console.error("Error fetching rank groups:", error);
    }
  };


  const fetchTeamRankGroups = async () => {
    try {
      const response = await fetch(
        `${webApi}/new_dashboards/sales_rank_group_dropdown/`,
        options
      );

      if (!response.ok) throw new Error("Failed to fetch rank groups");
      const data = await response.json();
      setTeamRankGroups(data);
    } catch (error) {
      console.error("Error fetching rank groups:", error);
    }
  };

  const fetchAttendanceData = async () => {
    try {
      setAttendanceTableLoading(true);

      let apiUrl = `${webApi}/new_dashboards/attendance_dashboard/?date=`;

      if (selectedAttendanceDate !== null) {
        apiUrl += selectedAttendanceDate;
      }

      const response = await fetch(apiUrl, options);
      if (!response.ok) throw new Error("Failed to fetch");

      const data = await response.json();
      if (data.is_admin) {
        setAttendanceDataForAdmin(data);
      } else {
        setAttendanceDataForAgent(data);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setAttendanceDataForAdmin(null);
      setAttendanceDataForAgent(null);
    } finally {
      setAttendanceTableLoading(false);
    }
  };

  const fetchCallBacksData = async () => {
    try {
      setCallBacksLoading(true);

      let apiUrl = `${webApi}/new_dashboards/call_back_schedules_dashboard/?date=`;

      if (selectedCallBackDate) {
        apiUrl += selectedCallBackDate.toLocaleDateString("en-CA");
      }

      const response = await fetch(apiUrl, options);
      if (!response.ok) throw new Error("Failed to fetch");

      const data = await response.json();
      setCallBacks(data);
    } catch (error) {
      console.error("Fetch error:", error);
      setCallBacks(null);
    } finally {
      setCallBacksLoading(false);
    }
  };

  const fetchPerformanceData = async () => {
    try {
      setPerformanceTableLoading(true);

      let apiUrl = `${webApi}/new_dashboards/performance_dashboard/`;

      if (selectedPerformanceDateRange !== null) {
        apiUrl += `?date=${selectedPerformanceDateRange}`;
      }

      if (selectedPerformanceAgent !== null) {
        apiUrl += selectedPerformanceDateRange ? `&agent_id=${selectedPerformanceAgent}` : `?agent_id=${selectedPerformanceAgent}`;
      }

      const response = await fetch(apiUrl, options);
      if (!response.ok) throw new Error("Failed to fetch");

      const data = await response.json();
      if (data.is_admin) {
        setPerformanceData(data);
        if (data?.date) {
          setSelectedPerformanceDateRange(data.date);
        }
      } else {
        setPerformanceData(data);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setPerformanceData(null);
    } finally {
      setPerformanceTableLoading(false);
    }
  };

  const fetchCurrentYearBranchClassWise = async () => {
    try {
      setCurrentYearBranchTableLoading(true);

      let apiUrl = `${webApi}/new_dashboards/branch_class_wise_sales_report/?branch_id=`;

      if (selectedCurrentYearBranch !== null) {
        apiUrl += selectedCurrentYearBranch;
      }

      const response = await fetch(apiUrl, options);
      if (!response.ok) throw new Error("Failed to fetch");

      const data = await response.json();
      setSelectedCurrentYearBranch(data.branch_id);
      setCurrentYearBranchClassWise(data); // ✅ single object
    } catch (error) {
      console.error("Fetch error:", error);
      setCurrentYearBranchClassWise(null);
    } finally {
      setCurrentYearBranchTableLoading(false);
    }
  };

  const fetchLastYearBranchClassWise = async () => {
    try {
      setLastYearBranchTableLoading(true);

      let apiUrl = `${webApi}/new_dashboards/branch_class_wise_renewals_report/?branch_id=`;

      if (selectedCurrentYearBranch !== null) {
        apiUrl += selectedCurrentYearBranch;
      }

      const response = await fetch(apiUrl, options);
      if (!response.ok) throw new Error("Failed to fetch");

      const data = await response.json();
      setSelectedCurrentYearBranch(data.branch_id);
      setLastYearBranchClassWise(data);
    } catch (error) {
      console.error("Fetch error:", error);
      setLastYearBranchClassWise(null);
    } finally {
      setLastYearBranchTableLoading(false);
    }
  };

  const fetchSalesRank = async () => {
    try {
      setSalesRankLoading(true);

      let apiUrl = `${webApi}/new_dashboards/wizklub_branch_sales_ranking_dashboard/?sale_rank_group=`;

      if (selectedGroup !== null) {
        apiUrl += selectedGroup;
      }

      if (selectedZone !== null) {
        apiUrl += `&branch__zone=${selectedZone}`;
      }

      const response = await fetch(apiUrl, options);
      if (!response.ok) throw new Error("Failed to fetch");

      const data = await response.json();
      setSelectedGroup(data.sale_rank_group);
      setSalesRank(data); // ✅ single object
    } catch (error) {
      console.error("Fetch error:", error);
      setSalesRank(null);
    } finally {
      setSalesRankLoading(false);
    }
  };

  const fetchTeamRank = async () => {
    try {
      setTeamRankLoading(true);

      let apiUrl = `${webApi}/new_dashboards/agnet_wizklub_sales_rank_group/?sales_rank_group=`;

      if (selectedTeamGroup !== null) {
        apiUrl += selectedTeamGroup;
      }

      const response = await fetch(apiUrl, options);
      if (!response.ok) throw new Error("Failed to fetch");

      const data = await response.json();
      setSelectedTeamGroup(data.sales_rank_group);
      setTeamRank(data); // ✅ single object
    } catch (error) {
      console.error("Fetch error:", error);
      setTeamRank(null);
    } finally {
      setTeamRankLoading(false);
    }
  };


  const fetchOverallTopThree = async () => {
    try {
      const response = await fetch(
        `${webApi}/new_dashboards/wizklub_overall_top_three_performers/`,
        options
      );
      const data = await response.json();
      setOverallTopThree(data);
    } catch (error) {
      console.error("Error fetching overall top three agents data:", error);
    }
  };

  const fetchTodayTopThree = async () => {
    try {
      const response = await fetch(
        `${webApi}/new_dashboards/wizklub_today_top_three_performers/`,
        options
      );
      const data = await response.json();
      setTodayTopThree(data);
    } catch (error) {
      console.error("Error fetching today's top three agents data:", error);
    }
  };

  const fetchSales = async () => {
    setWeeklySalesOfAgentLoading(true); // Set loading to true
    try {
      const response = await fetch(
        `${webApi}/new_dashboards/wizklub_sales_graph_dashboard/`,
        options
      );
      const data = await response.json();
      setSales(data.results);
      setSalesAdmin(data.is_admin);
      const categories = data.results.map((item: { label: any; }) => item.label);

      let series = [];

      if (data.is_admin) {
        // 👉 Admin: show target, new sales, renewals
        series = [
          {
            name: "Target",
            data: data.results.map((item: { target: any; }) => item.target),
          },
          {
            name: "New Sales",
            data: data.results.map((item: { new_sales: any; }) => item.new_sales ?? 0),
          },
          {
            name: "Renewals",
            data: data.results.map((item: { renewals: any; }) => item.renewals ?? 0),
          },
        ];
      } else {
        // 👉 Non-admin: show only sales & target
        series = [
          {
            name: "Sales",
            data: data.results.map((item: { sales: any; }) => item.sales),
          },
          {
            name: "Target",
            data: data.results.map((item: { target: any; }) => item.target),
          },
        ];
      }

      setChartData({
        chart: {
          height: 350,
          type: "bar",
          toolbar: { show: false },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            // borderRadius: 6,
          },
        },
        dataLabels: { enabled: false },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories,
        },
        yaxis: {
          title: {
            text: "Count",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: (val: number) => `${val}`,
          },
        },
        series,
      });
    } catch (error) {
      console.error("Error fetching sales data:", error);
    }
    finally {
      setWeeklySalesOfAgentLoading(false); // Set loading to false when done
    }
  };
  const fetchQuickLinks = async () => {
    try {
      const response = await fetch(
        `${webApi}/new_dashboards/dashboard_quicklinks/`,
        options
      );
      const data = await response.json();
      setQuickLinks(data);
    } catch (error) {
      console.error("Error fetching quick links:", error);
    }
  };

  const fetchCards = async (filter: FilterType) => {
    setLoading(true);

    try {
      const url =
        filter === "overall"
          ? `${webApi}/new_dashboards/get_dashboards_cards_data/`
          : `${webApi}/new_dashboards/get_dashboards_cards_with_date_filter_data/?date_filter=${filter}`;

      const response = await fetch(url, options);

      if (!response.ok) {
        const errorData = await response.json();

        if (errorData.code === "token_not_valid") {
          navigate("/login");
          return;
        }

        throw new Error(errorData.detail || "Failed to fetch card data");
      }

      const data = await response.json();
      setCards(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCards(filter);
  }, [filter]);

  function SampleNextArrow(props: any) {
    const { style, onClick } = props;
    return (
      <div
        className="slick-nav slick-nav-next"
        style={{ ...style, display: "flex", top: "30%", right: "30%" }}
        onClick={onClick}
      >
        <i className="fas fa-chevron-right" style={{ color: "#677788" }}></i>
      </div>
    );
  }

  function SamplePrevArrow(props: any) {
    const { style, onClick } = props;
    return (
      <div
        className="slick-nav slick-nav-prev"
        style={{ ...style, display: "flex", top: "30%", left: "30%" }}
        onClick={onClick}
      >
        <i className="fas fa-chevron-left" style={{ color: "#677788" }}></i>
      </div>
    );
  }

  const handleStatusChange = async (statusId: string | undefined) => {
    setSelectedStatus(statusId);

    if (selectedAgents.length > 0 && statusId) {
      const payload = {
        user_ids: selectedAgents,
      };

      try {
        const response = await fetch(
          `${webApi}/user_monitoring/change_multiple_agents_status/${statusId}/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${jwtToken}`,
            },
            body: JSON.stringify(payload),
          }
        );

        if (response.ok) {
          console.log("Status updated successfully");
          setIsStatusChange(true);
          setSelectedAgents([]);
          setSelectedStatus(undefined); // 👈 important
          fetchData();
        } else {
          console.error("Failed to update status");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  const handleCheckboxChange = (agentId: any) => {
    setSelectedAgents((prevSelected) => {
      if (prevSelected.includes(agentId)) {
        return prevSelected.filter((id) => id !== agentId);
      } else {
        return [...prevSelected, agentId];
      }
    });
  };
  const settings = {
    dots: true,
    autoplay: true,
    arrows: true,
    infinite: true,          // 🔥 important
    speed: 50,
    slidesToShow: 3,
    slidesToScroll: 1,       // 🔥 important
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const studentDonutChart = useMemo(() => ({
    chart: {
      height: 218,
      width: 218,
      type: "donut" as const, // ✅ TS fix
      toolbar: {
        show: false,
      },
    },
    legend: {
      show: false,
    },
    labels: ["Present", "Absent"],
    colors: ["#3D5EE1", "#6FCCD8"],
    series: attendanceDataForAdmin
      ? [
        attendanceDataForAdmin.no_of_present_agents,
        attendanceDataForAdmin.no_of_absent_agents,
      ]
      : [0, 0],
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 180,
          },
        },
      },
    ],
    plotOptions: {
      pie: {
        donut: {
          size: "60%",
          labels: {
            show: true,
            total: {
              show: true,
              label: "Agents",
              formatter: () =>
                attendanceDataForAdmin
                  ? `${attendanceDataForAdmin.total_agents}`
                  : "0",
            },
          },
        },
      },
    },
  }), [attendanceDataForAdmin]);
  const agentDonutChart = useMemo(() => ({
    chart: {
      height: 255,
      type: "donut" as const, // ✅ important
      toolbar: { show: false },
    },
    legend: {
      show: false,
    },
    labels: ["Present", "Absent"],
    colors: ["#3D5EE1", "#E04F5F"],
    series: attendanceDataForAgent
      ? [
        attendanceDataForAgent.no_of_present_days,
        attendanceDataForAgent.no_of_absent_days,
      ]
      : [0, 0],
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: { width: 200 },
        },
      },
    ],
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
          labels: {
            show: true,
            total: {
              show: true,
              label: "Days",
              formatter: () =>
                attendanceDataForAgent
                  ? `${attendanceDataForAgent.total_days}`
                  : "0",
            },
          },
        },
      },
    },
  }), [attendanceDataForAgent]);

  const student = {
    dots: false,
    autoplay: true,
    slidesToShow: 1,
    speed: 500,
    // nextArrow: <SampleNextArrow />,
    // prevArrow: <SamplePrevArrow />,
  };

  const student1 = {
    dots: false,
    autoplay: true,
    slidesToShow: 1,
    speed: 600,
    // nextArrow: <SampleNextArrow />,
    // prevArrow: <SamplePrevArrow />,
  };
  const teacher = {
    dots: false,
    autoplay: false,
    slidesToShow: 1,
    speed: 500,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  // const [classDonutChart] = useState<any>({
  //   chart: {
  //     height: 218,
  //     width: 218,
  //     type: "donut",
  //     toolbar: {
  //       show: false,
  //     },
  //   },
  //   labels: ["Achieved", "Remaining Target"],
  //   legend: { show: false },
  //   dataLabels: {
  //     enabled: false,
  //   },
  //   yaxis: {
  //     tickAmount: 3,
  //     labels: {
  //       offsetX: -15,
  //     },
  //   },
  //   grid: {
  //     padding: {
  //       left: -8,
  //     },
  //   },
  //   colors: ["#EAB300", "#3D5EE1"],
  //   responsive: [
  //     {
  //       breakpoint: 480,
  //       options: {
  //         chart: {
  //           width: 180,
  //         },
  //       },
  //     },
  //   ],
  // });

  const chartLabels = performanceAdmin
    ? selectedType === "New"
      ? ["New Sales", "Remaining"]
      : selectedType === "Renewals"
        ? ["Renewals", "Remaining"]
        : ["New Sales", "Renewals", "Remaining"]
    : ["Achieved", "Remaining"];
  const classDonutChart: ApexOptions = useMemo(() => {
    let colors: string[] = [];

    if (performanceAdmin) {
      if (selectedType === "New") {
        // New Sales + Remaining
        colors = ["#28C76F", "#3D5EE1"];
      } else if (selectedType === "Renewals") {
        // Renewals + Remaining
        colors = ["#EAB300", "#3D5EE1"];
      } else {
        // New + Renewals + Remaining
        colors = ["#28C76F", "#EAB300", "#3D5EE1"];
      }
    } else {
      // Achieved + Remaining
      colors = ["#EAB300", "#3D5EE1"];
    }

    return {
      chart: {
        height: 218,
        width: 218,
        type: "donut",
        toolbar: { show: false },
      },
      labels: chartLabels,
      legend: { show: false },
      dataLabels: { enabled: false },
      colors,
    };
  }, [performanceAdmin, selectedType, chartLabels]);

  const feesBar = useMemo(() => {
    // Base chart config (shared)
    const baseConfig: ApexCharts.ApexOptions = {
      chart: {
        height: 275,
        type: 'bar' as const,
        stacked: true,
        toolbar: { show: false },
      },
      legend: {
        show: true,
        horizontalAlign: 'left' as const,
        position: 'top' as const,
        fontSize: '14px',
        labels: { colors: '#5D6369' },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '40%',
          // endingShape: 'rounded',
        },
      },
      dataLabels: { enabled: false },
      stroke: { show: true, width: 1, colors: ['transparent'] },
      grid: { padding: { left: -8 } },
      xaxis: { categories: sales.map(item => item.label) },
      yaxis: { tickAmount: 3, labels: { offsetX: -15 } },
      fill: { opacity: 1 },
      tooltip: {
        y: {
          formatter: (val: number, { seriesIndex, dataPointIndex }: any): string => {
            const original = sales[dataPointIndex];
            // To access series names dynamically, we'll set them in the series array.
            // Fallback to index-based logic (but series names are better).
            if (!salesAdmin && seriesIndex === 0) return `${original.sales} `;
            if (!salesAdmin && seriesIndex === 1) {
              const remaining = Math.max(original.target, 0);
              return `${remaining}`;
            }
            if (salesAdmin) {
              const seriesName = feesBar.series[seriesIndex]?.name;
              if (seriesName === 'New Sales') return `${original.new_sales}`;
              if (seriesName === 'Target (New)') {
                const remaining = Math.max(original.target, 0);
                return `${remaining}`;
              }
              if (seriesName === 'Renewals') return `${original.renewals}`;
              if (seriesName === 'Target (Renewals)') {
                const remaining = Math.max(original.target, 0);
                return `${remaining}`;
              }
            }
            return `${val}`;
          },
        },
      },
    };

    // Conditional series and groups
    if (!salesAdmin) {
      // Non-admin: only one bar (new sales + target)
      return {
        ...baseConfig,
        colors: ['#3D5EE1', '#A0B4F0'],
        series: [
          { name: 'Sales', data: sales.map(item => item.sales) },
          { name: 'Target', data: sales.map(item => Math.max(item.target - item.sales, 0)) },
        ],
      };
    } else {
      // Admin: two separate bars (new sales group + renewals group)
      return {
        ...baseConfig,
        colors: ['#3D5EE1', '#E9EDF4', '#28C76F', '#E9EDF4'],
        plotOptions: {
          ...baseConfig.plotOptions,
          bar: {
            ...baseConfig.plotOptions?.bar,
            groups: [
              { name: 'New Sales Group' },
              { name: 'Renewals Group' },
            ],
          },
        },
        series: [
          { name: 'New Sales', data: sales.map(item => item.new_sales), group: 'new' },
          { name: 'Target (New)', data: sales.map(item => Math.max(item.target - item.new_sales, 0)), group: 'new' },
          { name: 'Renewals', data: sales.map(item => item.renewals), group: 'renewal' },
          { name: 'Target (Renewals)', data: sales.map(item => Math.max(item.target - item.renewals, 0)), group: 'renewal' },
        ],
      };
    }
  }, [sales]); // Add isAdmin to dependency array


  const WeeklyConversation = useMemo(() => ({
    chart: {
      height: 275,
      type: 'bar' as const,
      stacked: true,
      toolbar: {
        show: false,
      }
    },
    legend: {
      show: true,
      horizontalAlign: 'left' as const,
      position: 'top' as const,
      fontSize: '14px',
      labels: {
        colors: '#5D6369',
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '40%',
        endingShape: 'rounded'
      },
    },
    colors: ['#3D5EE1', '#E9EDF4'],
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 1,
      colors: ['transparent']
    },
    grid: {
      padding: {
        left: -8,
      },
    },
    // Map sales data to chart series
    series: [
      {
        name: "Conversation",
        data: weeklyConversationOfAgent.map(item =>
          Math.round(item.actual)
        ),
      },
      {
        name: "Target",
        data: weeklyConversationOfAgent.map(item =>
          Math.round(Math.max(item.target - item.actual, 0))
        ),
      },
    ],
    // Extract labels from sales data
    xaxis: {
      categories: weeklyConversationOfAgent.map(item => item.label)
    },
    yaxis: {
      tickAmount: 3,
      labels: {
        offsetX: -15
      },
    },
    fill: {
      opacity: 1
    },
    tooltip: {
      y: {
        formatter: (
          val: number,
          { seriesIndex, dataPointIndex }: any
        ): string => {

          const original = weeklyConversationOfAgent[dataPointIndex];

          if (seriesIndex === 0) {
            return `${original.actual} `;
          }

          if (seriesIndex === 1) {
            return `${original.target} `;
          }

          return `${val}`; // ✅ always return string
        }
      }
    }
  }), [weeklyConversationOfAgent]);


  const [totalEarningArea] = useState<any>({
    chart: {
      height: 90,
      type: 'area',
      toolbar: {
        show: false,
      },
      sparkline: {
        enabled: true
      }
    },
    colors: ['#3D5EE1'],
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'straight'
    },
    series: [{
      name: 'Earnings',
      data: [50, 55, 40, 50, 45, 55, 50]
    }]
  })
  const [totalExpenseArea] = useState<any>({
    chart: {
      height: 90,
      type: 'area',
      toolbar: {
        show: false,
      },
      sparkline: {
        enabled: true
      }
    },
    colors: ['#E82646'],
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'straight'
    },
    series: [{
      name: 'Expense',
      data: [40, 30, 60, 55, 50, 55, 40]
    }]
  })

  const progressColors = [
    "bg-primary",
    "bg-success",
    "bg-info",
    "bg-warning",
    "bg-danger",
    "bg-secondary",
    "bg-dark",
  ];


  const getTitle = (filter: FilterType) => {
    switch (filter) {
      case "today":
        return "Today Matrix";
      case "week":
        return "Week Matrix";
      case "month":
        return "Month Matrix";
      default:
        return "Overall Matrix";
    }
  };

  const formatINR = useCallback(
    (value: number) => value.toLocaleString('en-IN'),
    []
  );

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <>
            {/* Page Header */}

            <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
              <div className="my-auto mb-2">
                <h3 className="page-title mb-1">Wizklub Dashboard</h3>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to="#">Dashboard</Link>
                    </li>
                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                    >
                      Wizklub Dashboard
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                <div className="mb-2">
                  {/* <Link
                      to={routes.addStudent}
                      className="btn btn-primary d-flex align-items-center me-3"
                    >
                      <i className="ti ti-square-rounded-plus me-2" />
                      Add New Student
                    </Link> */}
                </div>
                <div className="mb-2">
                  {/* <Link
                      to={routes.collectFees}
                      className="btn btn-light d-flex align-items-center"
                    >
                      Fees Details
                    </Link> */}
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              {photoLoading ? (
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <LogoSpinnerInline />
                </div>
              ) : (
                <div className="col-md-12 d-flex">
                  <div
                    className="card flex-fill"
                    style={{
                      background: bgGradient,
                      border: "none",
                      transition: "background 0.4s ease",
                    }}
                  >
                    <div className="card-body" style={{ position: "relative" }}>
                      <h1 className="text-white mb-1">
                        Welcome {userData?.username.toLowerCase()}
                      </h1>
                      <p className="text-white mb-3">Have a Good day at work</p>

                      <div
                        style={{
                          position: "absolute",
                          right: 0,
                          top: 0,
                          height: "100%",
                          aspectRatio: "56 / 56", // ✅ force 1:1
                          // minWidth: "150px",
                          maxWidth: "45%",
                          overflow: "hidden",
                          pointerEvents: "none",
                        }}
                      >
                        <img
                          src={photo1}
                          alt="User Profile"
                          crossOrigin="anonymous"
                          onLoad={(e) => extractColor(e.currentTarget)}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",

                            /* clarity */
                            filter: "brightness(1.08) contrast(1.15) saturate(1.15)",

                            /* smooth blend */
                            WebkitMaskImage:
                              "linear-gradient(to left, rgba(0,0,0,1), rgba(0,0,0,0.7))",
                            maskImage:
                              "linear-gradient(to left, rgba(0,0,0,1), rgba(0,0,0,0))",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* <div className="row">
              {cardLoading ? (
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <LogoSpinnerInline />
                </div>
              ) : (
                cards.map((card, index) => (
                  <div
                    key={card.id}
                    className="col-xxl-3 col-sm-6 d-flex"
                  >
                    <motion.div
                      className="card flex-fill animate-card border-0"
                      variants={cardVariants}
                      initial="hidden"
                      animate="visible"
                      custom={index}
                      whileHover={{
                        y: -6,
                        scale: 1.02,
                        boxShadow: "0px 10px 25px rgba(0,0,0,0.12)",
                      }}
                    >
                      <div className="card-body">
                        
                        <div className="d-flex align-items-center">
                          <div className="avatar avatar-xl me-2 p-1">
                            <ImageWithBasePath
                              src={card.logo}
                              alt={card.heading}
                            />
                          </div>

                          <div className="overflow-hidden flex-fill">
                            <div className="d-flex align-items-center justify-content-between">
                              <h2 className="counter">
                                <CountUp end={Number(card.heading_value)} />
                              </h2>

                              <span
                                className={`badge ${Number(card.percentage) < 25
                                  ? "bg-danger"
                                  : Number(card.percentage) < 50
                                    ? "bg-warning"
                                    : Number(card.percentage) < 75
                                      ? "bg-primary"
                                      : "bg-success"
                                  }`}
                              >
                                {card.percentage}%
                              </span>
                            </div>

                            <p>{card.heading}</p>
                          </div>
                        </div>

                        
                        <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                          <p className="mb-0">
                            {card.sub_heading_1} :{" "}
                            <span className="text-dark fw-semibold">
                              {card.sub_heading_1_value}
                            </span>
                          </p>

                          <span className="text-light">|</span>

                          <p className="mb-0">
                            {card.sub_heading_2} :{" "}
                            <span className="text-dark fw-semibold">
                              {card.sub_heading_2_value}
                            </span>
                          </p>
                        </div>
                      </div>
                    </motion.div>
                  </div>
                ))
              )}
            </div> */}
            <div className="row">
              <div className="d-flex align-items-center justify-content-between flex-wrap">

                {/* LEFT */}
                <h3 className="page-title mb-2">{getTitle(filter)}</h3>

                {/* RIGHT */}
                <div className="mb-2" style={{ minWidth: "150px" }}>
                  <select
                    className="form-select"
                    value={filter}
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                      setFilter(e.target.value as FilterType)
                    }
                  >
                    <option value="overall">Overall</option>
                    <option value="today">Today</option>
                    <option value="week">Week</option>
                    <option value="month">Month</option>
                  </select>
                </div>
              </div>

              {loading ? (
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <LogoSpinnerInline />
                </div>
              ) : (
                formatCardsData(cards).map((card: CardItem, index: number) => (
                  <div key={card.id} className="col-xxl-3 col-sm-6 d-flex">
                    <motion.div
                      className="card flex-fill animate-card border-0"
                      variants={cardVariants}
                      initial="hidden"
                      animate="visible"
                      custom={index}
                      whileHover={{
                        y: -6,
                        scale: 1.02,
                        boxShadow: "0px 10px 25px rgba(0,0,0,0.12)",
                      }}
                    >
                      <div className="card-body">

                        {/* Top */}
                        <div className="d-flex align-items-center">
                          <div className="avatar avatar-xl me-2 p-1">
                            <ImageWithBasePath src={card.logo} alt={card.heading} />
                          </div>

                          <div className="overflow-hidden flex-fill">
                            <div className="d-flex align-items-center justify-content-between">
                              <h2 className="counter">
                                <CountUp
                                  end={Number(card.heading_value)}
                                  formattingFn={formatINR}
                                />
                              </h2>

                              <span
                                className={`badge ${Number(card.percentage) < 25
                                  ? "bg-danger"
                                  : Number(card.percentage) < 50
                                    ? "bg-warning"
                                    : Number(card.percentage) < 75
                                      ? "bg-primary"
                                      : "bg-success"
                                  }`}
                              >
                                {card.percentage}%
                              </span>
                            </div>

                            <p>{card.heading}</p>
                          </div>
                        </div>

                        {/* Bottom */}
                        <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                          <p className="mb-0">
                            {card.sub_heading_1} :{" "}
                            <span className="text-dark fw-semibold">
                              {card.sub_heading_1_value}
                            </span>
                          </p>

                          <span className="text-light">|</span>

                          <p className="mb-0">
                            {card.sub_heading_2} :{" "}
                            <span className="text-dark fw-semibold">
                              {card.sub_heading_2_value}
                            </span>
                          </p>
                        </div>

                      </div>
                    </motion.div>
                  </div>
                ))
              )}
            </div>
            <div className="row">
              {/* Schedules */}
              <div className="col-xxl-4 col-xl-6 col-md-12 d-flex">
                <div className="card flex-fill">
                  <div className="card-header d-flex align-items-center justify-content-between">
                    <div>
                      <h4 className="card-title">Schedules</h4>
                    </div>
                    {/* <Link
                      to="#"
                      className="link-primary fw-medium me-2"
                      data-bs-toggle="modal"
                      data-bs-target="#add_event"
                    >
                      <i className="ti ti-square-plus me-1" />
                      Add New
                    </Link> */}
                  </div>
                  <div className="card-body ">
                    {/* <div className="datepic mb-4" /> */}
                    <Calendar
                      className="datepickers mb-4"
                      value={selectedCallBackDate}
                      onChange={(e) => setSelectedCallBackDate(e.value ?? null)}
                      inline
                    />
                    <h5 className="mb-3">Upcoming CallBacks</h5>
                    <div className="event-wrapper ">
                      {/* Event Item */}
                      <div className="card-body py-1">
                        {callBacksLoading ? (
                          <div
                            style={{
                              height: "100%",
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <LogoSpinnerInline />
                          </div>
                        ) : !callBacks ? (
                          <div className="text-center py-4 text-muted">
                            No callback data available
                          </div>
                        ) : (
                          <>

                            {/* TOTAL CALLBACKS */}
                            <motion.div
                              className="card mb-3"
                              variants={cardVariants}
                              initial="hidden"
                              animate="visible"
                              // custom={index}
                              whileHover={{
                                y: -6,
                                scale: 1.02,
                                boxShadow: "0px 10px 25px rgba(0,0,0,0.12)",
                              }}
                            >
                              <div className="card-body d-flex align-items-center justify-content-between">
                                <div>
                                  <motion.p
                                    className="text-primary mb-1"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ delay: 0.3 }}
                                  >
                                    <i className="ti ti-phone-call me-2" />
                                    Total Callbacks
                                  </motion.p>

                                  <h4 className="mb-1">{total}</h4>
                                  <small className="text-muted">{callBacks.date}</small>
                                </div>

                                <motion.div
                                  initial={{ scale: 0.85, opacity: 0 }}
                                  animate={{ scale: 1, opacity: 1 }}
                                  transition={{ delay: 0.35 }}
                                >
                                  <CircleProgress value={100} />
                                </motion.div>
                              </div>
                            </motion.div>



                            {/* MORNING CALLBACKS */}
                            <motion.div
                              className="card mb-3"
                              variants={cardVariants}
                              initial="hidden"
                              animate="visible"
                              // custom={index}
                              whileHover={{
                                y: -6,
                                scale: 1.02,
                                boxShadow: "0px 10px 25px rgba(0,0,0,0.12)",
                              }}
                            >
                              <div className="card-body d-flex align-items-center justify-content-between">
                                <div>
                                  <p className="text-success mb-1">
                                    <i className="ti ti-sunrise me-2" />
                                    Morning Callbacks
                                  </p>
                                  <small className="text-muted">00:00 – 12:00</small>
                                  <h4 className="mb-1">{morning}</h4>
                                </div>

                                <motion.div
                                  initial={{ rotate: -90, opacity: 0 }}
                                  animate={{ rotate: 0, opacity: 1 }}
                                  transition={{ delay: 0.35, duration: 0.6 }}
                                >
                                  <CircleProgress value={percent(morning)} />
                                </motion.div>
                              </div>
                            </motion.div>



                            {/* AFTERNOON CALLBACKS */}
                            <motion.div
                              className="card mb-3"
                              variants={cardVariants}
                              initial="hidden"
                              animate="visible"
                              // custom={index}
                              whileHover={{
                                y: -6,
                                scale: 1.02,
                                boxShadow: "0px 10px 25px rgba(0,0,0,0.12)",
                              }}
                            >
                              <div className="card-body d-flex align-items-center justify-content-between">
                                <div>
                                  <p className="text-warning mb-1">
                                    <i className="ti ti-sun me-2" />
                                    Afternoon Callbacks
                                  </p>
                                  <small className="text-muted">12:00 – 16:00</small>
                                  <h4 className="mb-1">{afternoon}</h4>
                                </div>

                                <motion.div
                                  initial={{ opacity: 0, scale: 0.9 }}
                                  animate={{ opacity: 1, scale: 1 }}
                                  transition={{ delay: 0.25 }}
                                >
                                  <CircleProgress value={percent(afternoon)} />
                                </motion.div>
                              </div>
                            </motion.div>



                            {/* EVENING CALLBACKS */}
                            <motion.div
                              className="card"
                              variants={cardVariants}
                              initial="hidden"
                              animate="visible"
                              // custom={index}
                              whileHover={{
                                y: -6,
                                scale: 1.02,
                                boxShadow: "0px 10px 25px rgba(0,0,0,0.12)",
                              }}
                            >
                              <div className="card-body d-flex align-items-center justify-content-between">
                                <div>
                                  <p className="text-danger mb-1">
                                    <i className="ti ti-moon me-2" />
                                    Evening Callbacks
                                  </p>
                                  <small className="text-muted">16:00 – 23:59</small>
                                  <h4 className="mb-1">{evening}</h4>
                                </div>
                                <CircleProgress value={percent(evening)} />
                              </div>
                            </motion.div>
                          </>
                        )}
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              {/* /Schedules */}
              {/* Attendance */}
              <div className="col-xxl-4 col-xl-6 col-md-12 d-flex flex-column">
                <div className="card">
                  <div className="card-header d-flex align-items-center justify-content-between">
                    <h4 className="card-title">Attendance</h4>
                    <div className="d-flex align-items-center">
                      <div>
                        <DatePicker
                          allowClear={true}
                          placeholder="Select Date"
                          format="YYYY-MM-DD"
                          onChange={(date) => {
                            if (date) {
                              setSelectedAttendanceDate(date.format("YYYY-MM-DD"));
                            }
                          }}
                        />
                      </div>

                    </div>
                  </div>
                  {attendanceTableLoading ? (
                    <div
                      style={{
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <LogoSpinnerInline />
                    </div>
                  ) : (
                    <>
                      {/* ADMIN VIEW */}
                      {isAdmin && attendanceDataForAdmin && (
                        <div className="card-body">
                          <div className="tab-content">
                            <div className="tab-pane fade active show" id="students">
                              <div className="row gx-3">
                                <div className="col-sm-4">
                                  <div className="card bg-light-300 shadow-none border-0">
                                    <div className="card-body p-3 text-center" onClick={handlePresentClick} data-bs-toggle="modal"
                                      data-bs-target="#exampleModalScrollable3">
                                      <h5>{attendanceDataForAdmin.no_of_present_agents}</h5>
                                      <p className="fs-12">Present</p>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-sm-4">
                                  <div className="card bg-light-300 shadow-none border-0">
                                    <div className="card-body p-3 text-center" onClick={handleAbsentClick} data-bs-toggle="modal"
                                      data-bs-target="#exampleModalScrollable3">
                                      <h5>{attendanceDataForAdmin.no_of_absent_agents}</h5>
                                      <p className="fs-12">Absent</p>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-sm-4">
                                  <div className="card bg-light-300 shadow-none border-0" onClick={handlePresentClick}>
                                    <div className="card-body p-3 text-center">
                                      <h5>{attendanceDataForAdmin.total_agents}</h5>
                                      <p className="fs-12">Total Agents</p>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="text-center">
                                <ReactApexChart
                                  className="mb-4"
                                  options={studentDonutChart}
                                  series={studentDonutChart.series}
                                  type="donut"
                                  height={200}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* AGENT VIEW */}
                      {!isAdmin && attendanceDataForAgent && (
                        <div className="card-body">
                          <div className="attendance-chart">
                            <p className="mb-3">
                              <i className="ti ti-calendar-heart text-primary me-2" />
                              No of total working days
                              <span className="fw-medium text-dark">
                                {" "}
                                {attendanceDataForAgent.total_days} Days
                              </span>
                            </p>

                            <div className="border rounded p-3">
                              <div className="row">
                                <div className="col text-center border-end">
                                  <p className="mb-1">Present</p>
                                  <h5>{attendanceDataForAgent.no_of_present_days}</h5>
                                </div>

                                <div className="col text-center border-end">
                                  <p className="mb-1">Absent</p>
                                  <h5>{attendanceDataForAgent.no_of_absent_days}</h5>
                                </div>
                              </div>
                            </div>

                            <div className="text-center">
                              <ReactApexChart
                                options={agentDonutChart}
                                series={agentDonutChart.series}
                                type="donut"
                                height={255}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
                <div className="row flex-fill">
                  {/* Best Performer */}
                  <div className="col-sm-6 d-flex flex-column">
                    <div className="br-5 text-center flex-fill mb-4 pb-0 owl-height">

                      {todayTopThree.length > 0 ? (
                        <Slider {...student} className="owl-carousel student-slider h-100">
                          {todayTopThree.map((agent) => {
                            const imageUrl = agent.agent_profile
                              ? agent.agent_profile
                              : "assets/img/performer/performer-01.png";

                            return (
                              <div className="item h-100" key={agent.agent_id}>
                                <div
                                  className="d-flex flex-column justify-content-end h-100"
                                  style={{
                                    backgroundImage: `
                                      linear-gradient(
                                        to top,
                                        rgba(0,0,0,0.85),
                                        rgba(0,0,0,0.4),
                                        rgba(0,0,0,0.05)
                                      ),
                                      url(${imageUrl})
                                    `,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    borderRadius: "8px",
                                    minHeight: "350px",
                                    // padding: "20px",
                                  }}
                                >
                                  <h5 className="mb-2 text-white">
                                    Today’s Top Performer
                                  </h5>
                                  <h4 className="mb-1 text-white text-capitalize">
                                    {agent.agent_name}
                                  </h4>
                                  <p className="mb-0 text-light">
                                    Sales: {agent.sales_count}
                                  </p>
                                </div>
                              </div>
                            );
                          })}
                        </Slider>
                      ) : (
                        <div
                          style={{
                            borderRadius: "8px",
                            minHeight: "100%",
                            background: "linear-gradient(135deg, #f6f9fc, #e9eff5)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            transition: "all 0.8s ease",
                          }}
                        >
                          <div
                            style={{
                              textAlign: "center",
                              transition: "all 0.8s ease",
                              opacity: animate ? 1 : 0.6,
                              transform: animate
                                ? "translateY(-6px)"
                                : "translateY(6px)",
                            }}
                          >
                            <h4 style={{ marginBottom: "8px", color: "#333" }}>
                              Today’s Top Performer
                            </h4>
                            <p style={{ color: "#666", letterSpacing: "1px" }}>
                              Coming Soon...
                            </p>
                          </div>
                        </div>
                      )}

                    </div>
                  </div>


                  {/* /Best Performer */}
                  {/* Star Students */}
                  <div className="col-sm-6 d-flex flex-column">
                    <div className="br-5 text-center flex-fill mb-4 pb-0 owl-height">
                      {overallTopThree.length > 0 ? (
                        <Slider {...student1} className="owl-carousel student-slider h-100">
                          {overallTopThree.map((agent) => {
                            const imageUrl = agent.agent_profile
                              ? agent.agent_profile
                              : "assets/img/performer/performer-01.png";

                            return (
                              <div className="item h-100" key={agent.agent_id}>
                                <div
                                  className="d-flex flex-column justify-content-end h-100"
                                  style={{
                                    backgroundImage: `
                                    linear-gradient(
                                      to top,
                                      rgba(0,0,0,0.85),
                                      rgba(0,0,0,0.4),
                                      rgba(0,0,0,0.05)
                                    ),
                                    url(${imageUrl})
                                  `,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    borderRadius: "10px",
                                    minHeight: "350px",
                                  }}
                                >
                                  <h5 className="mb-2 text-white">
                                    Overall Top Performer
                                  </h5>

                                  <h3 className="mb-1 text-white text-capitalize">
                                    {agent.agent_name}
                                  </h3>

                                  <p className="mb-0 text-light">
                                    Sales: {agent.sales_count}
                                  </p>
                                </div>
                              </div>
                            );
                          })}
                        </Slider>
                      ) : (
                        <div
                          style={{
                            borderRadius: "8px",
                            minHeight: "100%",
                            background: "linear-gradient(135deg, #f6f9fc, #e9eff5)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            transition: "all 0.8s ease",
                          }}
                        >
                          <div
                            style={{
                              textAlign: "center",
                              transition: "all 0.8s ease",
                              opacity: animate ? 1 : 0.6,
                              transform: animate
                                ? "translateY(-6px)"
                                : "translateY(6px)",
                            }}
                          >
                            <h4 style={{ marginBottom: "8px", color: "#333" }}>
                              Over All Top Performer
                            </h4>
                            <p style={{ color: "#666", letterSpacing: "1px" }}>
                              Coming Soon...
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* /Star Students */}
                </div>
              </div>
              {/* /Attendance */}
              <div className="col-xxl-4 col-md-12 d-flex flex-column">
                {/* Quick Links */}
                <div className="card flex-fill">
                  <div className="card-header d-flex align-items-center justify-content-between">
                    <h4 className="card-title">Quick Links</h4>
                  </div>

                  <div className="card-body pb-1">
                    <div className="row">
                      {sortedQuickLinks.map((link) => (
                        <div
                          key={link.id}
                          className="col-lg-4 col-md-6 col-sm-6 col-12 mb-3"
                        >
                          <Link
                            to={link.front_end_url}
                            className="d-block rounded p-2 text-center class-hover"
                            style={{ backgroundColor: `#${link.bg_color}` }}
                          >
                            <div className="avatar avatar-lg border rounded-circle mb-2 p-1">
                              <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 rounded-circle">
                                <img
                                  src={link.logo}
                                  alt={link.name}
                                  className="img-fluid"
                                />
                              </span>
                            </div>

                            <p className="text-dark">{link.name}</p>
                          </Link>
                        </div>
                      ))}
                    </div>

                  </div>
                </div>
                {/* /Quick Links */}
                {/* Class Routine */}
                <div className="col-md-12 col-12 d-flex ">
                  <div className="card flex-fill">
                    <div className="card-header d-flex align-items-center justify-content-between">
                      <h4 className="card-title">Sales</h4>
                      {/* <Link
                      to="#"
                      className="link-primary fw-medium"
                      data-bs-toggle="modal"
                      data-bs-target="#add_class_routine"
                    >
                      <i className="ti ti-square-plus me-1" />
                      Add New
                    </Link> */}
                    </div>
                    <div className="card-body">
                      {monthlySales.map((item, index) => {
                        const percentage =
                          item.target > 0
                            ? Math.min((item.sales / item.target) * 100, 100)
                            : 0;

                        const progressColor =
                          item.target === 0
                            ? "bg-secondary"
                            : percentage >= 75
                              ? "bg-success"
                              : percentage >= 50
                                ? "bg-info"
                                : percentage >= 25
                                  ? "bg-warning"
                                  : "bg-danger";
                        return (
                          <div
                            key={index}
                            className="d-flex align-items-center rounded border p-3 mb-3"
                          >
                            <span className="avatar avatar-md flex-shrink-0 border rounded me-2">
                              <ImageWithBasePath
                                src={`/assets/img/logo.png`}
                                className="rounded"
                                alt="Profile"
                              />
                            </span>

                            <div className="w-100">
                              <div className="d-flex justify-content-between mb-1">
                                <p className="mb-0">{item.label}</p>
                                <small>
                                  {item.sales} / {item.target}
                                </small>
                              </div>

                              <div className="progress progress-xs flex-grow-1">
                                <div
                                  className={`progress-bar progress-bar-striped progress-bar-animated ${progressColor} rounded`}
                                  role="progressbar"
                                  style={{ width: `${percentage}%` }}
                                  aria-valuenow={percentage}
                                  aria-valuemin={0}
                                  aria-valuemax={100}
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                {/* /Class Routine */}
                {/* Class Wise Performance */}
                <div className="col-md-12 col-12 d-flex">
                  <div className="card flex-fill">
                    <div className="card-header d-flex align-items-center justify-content-between">
                      <h4 className="card-title">Performance</h4>
                      <div className="d-flex align-items-center flex-wrap gap-2 ">
                        <div className="me-1">
                          <DatePicker
                            allowClear={true}
                            placeholder="Date"
                            format="YYYY-MM-DD"
                            value={
                              selectedPerformanceDateRange
                                ? dayjs(selectedPerformanceDateRange, "YYYY-MM-DD")
                                : null
                            }
                            style={{ width: 100, }}
                            onChange={(date) => {
                              if (date) {
                                setSelectedPerformanceDateRange(date.format("YYYY-MM-DD"));
                              }
                            }}
                          />
                        </div>
                        <div className="me-1">
                          <Select
                            showSearch
                            allowClear
                            placeholder="Agent"
                            value={selectedPerformanceAgent}
                            onChange={(value) => setSelectedPerformanceAgent(value ?? null)}
                            style={{ width: 100, borderTopColor: '#fff', borderLeftColor: '#fff', borderRightColor: '#fff' }}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            options={performanceAgents.map(group => ({
                              value: group.id,
                              label: group.username,
                            }))}
                          />
                        </div>
                        <div>
                          <Select
                            showSearch
                            // allowClear
                            placeholder="Select Type"
                            value={selectedType}
                            onChange={(value) => setSelectedType(value ?? null)}
                            style={{
                              width: 100,
                              borderTopColor: "#fff",
                              borderLeftColor: "#fff",
                              borderRightColor: "#fff",
                            }}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            options={[
                              { value: "New", label: "New" },
                              { value: "Renewals", label: "Renewals" },
                            ]}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      {performanceTableLoading ? (
                        <div
                          style={{
                            height: "100%",
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <LogoSpinnerInline />
                        </div>
                      ) : (
                        <div className="d-md-flex align-items-center justify-content-between">
                          <div className="me-md-3 mb-3 mb-md-0 w-100">

                            {performanceAdmin ? (
                              <>
                                <div className="border border-dashed p-3 rounded d-flex justify-content-between mb-1">
                                  <p className="mb-0">
                                    <i className="ti ti-arrow-badge-down-filled me-2 text-primary" />
                                    Target
                                  </p>
                                  <h5>{target}</h5>
                                </div>

                                {/* <div className="border border-dashed p-3 rounded d-flex justify-content-between mb-1">
                                  <p className="mb-0">
                                    <i className="ti ti-arrow-badge-down-filled me-2 text-warning" />
                                    Achieved
                                  </p>
                                  <h5>{achieved}</h5>
                                </div> */}


                                {(selectedType === "New" || selectedType === null) && (
                                  <div className="border border-dashed p-3 rounded d-flex justify-content-between mb-1">
                                    <p className="mb-0">
                                      <i className="ti ti-arrow-badge-down-filled me-2 text-success" />
                                      New Sales
                                    </p>
                                    <h5>{newSales}</h5>
                                  </div>
                                )}

                                {(selectedType === "Renewals" || selectedType === null) && (
                                  <div className="border border-dashed p-3 rounded d-flex justify-content-between mb-1">
                                    <p className="mb-0">
                                      <i
                                        className="ti ti-arrow-badge-down-filled me-2"
                                        style={{ color: "#EAB300" }}
                                      />
                                      Renewals
                                    </p>
                                    <h5>{renewals}</h5>
                                  </div>
                                )}
                              </>
                            ) : (
                              <>
                                <div className="border border-dashed p-3 rounded d-flex justify-content-between mb-1">
                                  <p className="mb-0">
                                    <i className="ti ti-arrow-badge-down-filled me-2 text-primary" />
                                    Target
                                  </p>
                                  <h5>{target}</h5>
                                </div>

                                <div className="border border-dashed p-3 rounded d-flex justify-content-between mb-1">
                                  <p className="mb-0">
                                    <i className="ti ti-arrow-badge-down-filled me-2 text-warning" />
                                    Achieved
                                  </p>
                                  <h5>{achieved}</h5>
                                </div>

                                {/* <div className="border border-dashed p-3 rounded d-flex justify-content-between mb-1">
                                  <p className="mb-0">
                                    <i className="ti ti-arrow-badge-down-filled me-2 text-primary" />
                                    Remaining
                                  </p>
                                  <h5>{Math.max(target - achieved, 0)}</h5>
                                </div> */}
                              </>
                            )}

                          </div>
                          <ReactApexChart
                            // id="class-chart"
                            type="donut"
                            options={classDonutChart}
                            series={series}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* /Class Wise Performance */}
              </div>
            </div>
            <div className="row">


              <div className="col-xxl-12 col-xl-12 d-flex">
                <div className="card flex-fill">
                  <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                    <h4 className="card-title mb-3">Agent Activity</h4>
                    <div className="d-flex align-items-center me-3 mb-3">
                      <Select
                        showSearch
                        allowClear
                        placeholder="Select Status"
                        value={selectedStatus}
                        onChange={handleStatusChange}
                        disabled={selectedAgents.length === 0}
                        style={{ width: 150, borderTopColor: '#fff', borderLeftColor: '#fff', borderRightColor: '#fff' }}
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={monitoringStatus.map(group => ({
                          value: group.id,
                          label: group.name,
                        }))}
                      />
                      <BiRefresh
                        className={`refresh-icon ${refreshIsLoading ? "spin" : ""} ms-3`}
                        onClick={fetchData}
                      />
                    </div>
                  </div>
                  {refreshIsLoading ? (
                    <div
                      style={{
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <LogoSpinnerInline />
                    </div>
                  ) : (
                    <div className="card-body px-0">
                      <div
                        className="custom-datatable-filter table-responsive"
                        style={{ maxHeight: "480px", overflowY: "auto" }} // scroll here
                      >
                        <table className="table table-hover mb-0">
                          <thead className="thead-light" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            <tr>
                              <th>Action</th>
                              <th>Agent Name</th>
                              <th>Status</th>
                              <th>Session Duration</th>
                              <th>Calls</th>
                              <th>Connected</th>
                              <th>Interested</th>
                              <th>Call backs</th>
                              <th>Sale</th>
                              <th>Idle Time</th>
                            </tr>
                          </thead>

                          <tbody>
                            {dashboardData?.map((agent) => (
                              <tr key={agent.id} style={{ height: "48px" }}>
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={selectedAgents.includes(agent.id)}
                                    onChange={() => handleCheckboxChange(agent.id)}
                                    disabled={
                                      agent.status_name === "Offline" ||
                                      agent.status_name === "On Call"
                                    }
                                  />
                                </td>

                                <td><div className="d-flex align-items-center">
                                  <div className="avatar avatar-md">
                                    <ImageWithBasePath
                                      src={
                                        agent.profile_pic
                                          ? `${webApi}${agent.profile_pic}`
                                          : "/assets/img/logo.png"
                                      }
                                      className="img-fluid rounded-circle"
                                      alt="img"
                                    />
                                  </div><div className="ms-2"><p className="text-dark mb-0">{agent.agent_name}</p></div></div></td>
                                <td>
                                  {(() => {
                                    let badgeClass = "badge bg-secondary";

                                    if (agent.status_name === "Available") {
                                      badgeClass = "badge bg-success";
                                    } else if (agent.status_name === "Offline") {
                                      badgeClass = "badge bg-danger";
                                    } else if (agent.status_name === "Work Assign") {
                                      badgeClass = "badge bg-info";
                                    }

                                    return (
                                      <>
                                        <span>
                                          <i className={`${badgeClass} ti ti-circle-filled fs-9`} />
                                        </span>
                                        <span>{agent.status_name}</span>
                                      </>
                                    );
                                  })()}
                                </td>

                                <td>
                                  <Counter updatedAt={agent.updated_at} />
                                </td>
                                <td>{agent.calls}</td>
                                <td>{agent.connected}</td>
                                <td>{agent.interested}</td>
                                <td>{agent.callbacks}</td>
                                <td>{agent.sale}</td>
                                <td>
                                  {(() => {
                                    const [h = 0, m = 0, s = 0] = agent.total_ideal_time
                                      .split(":")
                                      .map(Number);

                                    const seconds = h * 3600 + m * 60 + s;

                                    let badgeClass = "badge bg-danger";

                                    if (seconds <= 300) {
                                      badgeClass = "badge bg-success";
                                    } else if (seconds <= 900) {
                                      badgeClass = "badge bg-warning";
                                    }

                                    return (
                                      <>
                                        <span>{agent.total_ideal_time}</span>{" "}
                                      </>
                                    );
                                  })()}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
              </div>


            </div>
            <div className="row">
              {/* Fees Collection */}
              <div className="col-xxl-6 col-xl-6 d-flex">
                <div className="card flex-fill">
                  <div className="card-header d-flex align-items-center justify-content-between">
                    <h4 className="card-title">Weekly Sales</h4>
                  </div>

                  <div className="card-body pb-0">
                    {weeklySalesOfAgentLoading ? (
                      <div
                        style={{
                          height: "350px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <LogoSpinnerInline />
                      </div>
                    ) : chartData?.series?.length ? (
                      <ReactApexChart
                        options={chartData}
                        series={chartData.series}
                        type="bar"
                        height={350}
                      />
                    ) : (
                      <div className="text-center py-4">No data available</div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-xxl-6 col-xl-6 d-flex">
                <div className="card flex-fill">
                  <div className="card-header  d-flex align-items-center justify-content-between">
                    <h4 className="card-title">Weekly Conversation Of Agent</h4>
                  </div>
                  <div className="card-body pb-0">
                    {weeklySalesOfAgentLoading ? (
                      <div
                        style={{
                          height: "100%",
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <LogoSpinnerInline />
                      </div>
                    ) : (
                      <ReactApexChart
                        id="fees-chart"
                        options={WeeklyConversation}
                        series={WeeklyConversation.series}
                        type="bar"
                        height={270}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            {checkPermission("view_wizklub_sales_revenue", "custom_model") && (
              <div className="row">
                <div className="col-xxl-6 col-xl-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-header d-flex align-items-center justify-content-between">
                      <h4 className="card-title">Sales Statistics</h4>
                    </div>
                    <div className="card-body pb-0">
                      <div id="statistic_chart" />
                      {salesStatsLoading ? (
                        <div
                          style={{
                            height: "100%",
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <LogoSpinnerInline />
                        </div>
                      ) : (
                        <ReactApexChart
                          id="Sales_chart"
                          options={Sales_chart}
                          series={Sales_chart.series}
                          type="line"
                          height={345}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-header d-flex align-items-center justify-content-between">
                      <h4 className="card-title">Revenue Statistics</h4>
                    </div>
                    <div className="card-body pb-0">
                      <div id="Revenue_chart" />
                      {revenueStatsLoading ? (
                        <div
                          style={{
                            height: "100%",
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <LogoSpinnerInline />
                        </div>
                      ) : (
                        <ReactApexChart
                          id="Revenue_chart"
                          options={Revenue_chart}
                          series={Revenue_chart.series}
                          type="line"
                          height={345}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {checkPermission("view_wizklub_sales_revenue", "custom_model") && (
              <div className="row">
                {/* Achieved Sales */}
                <div className="col-xxl-3 col-xl-3 col-md-6 d-flex flex-column">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <p className="mb-2">Achieved Sales</p>
                      <div className="d-flex align-items-end justify-content-between">
                        <h4>
                          {revenueAndSalesStats?.achieved_sales ?? "--"}
                        </h4>

                        <span
                          className={`badge ${parseFloat(revenueAndSalesStats?.sales_growth_percentage ?? "0") >= 75
                            ? "badge-soft-success"
                            : parseFloat(revenueAndSalesStats?.sales_growth_percentage ?? "0") >= 50
                              ? "badge-soft-info"
                              : parseFloat(revenueAndSalesStats?.sales_growth_percentage ?? "0") >= 25
                                ? "badge-soft-warning"
                                : "badge-soft-danger"
                            }`}
                        >
                          <i className="ti ti-chart-line me-1" />
                          {revenueAndSalesStats?.sales_growth_percentage ?? "--"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Target Sales */}
                <div className="col-xxl-3 col-xl-3 col-md-6 d-flex flex-column">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <p className="mb-2">Target Sales</p>
                      <div className="d-flex align-items-end justify-content-between">
                        <h4>
                          {revenueAndSalesStats?.target_sales ?? "--"}
                        </h4>

                        {/* <span
                        className={`badge ${Number(revenueAndSalesStats?.sales_growth_percentage) >= 0
                          ? "badge-soft-success"
                          : "badge-soft-danger"
                          }`}
                      >
                        <i className="ti ti-chart-line me-1" />
                        {revenueAndSalesStats?.sales_growth_percentage ?? "--"}%
                      </span> */}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Achieved Revenue */}
                <div className="col-xxl-3 col-xl-3 col-md-6 d-flex flex-column">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <p className="mb-2">Achieved Revenue</p>
                      <div className="d-flex align-items-end justify-content-between">
                        <h4>
                          ₹{revenueAndSalesStats?.achieved_revenue ?? "--"}
                        </h4>

                        <span
                          className={`badge ${parseFloat(revenueAndSalesStats?.revenue_growth_percentage ?? "0") >= 75
                            ? "badge-soft-success"
                            : parseFloat(revenueAndSalesStats?.revenue_growth_percentage ?? "0") >= 50
                              ? "badge-soft-info"
                              : parseFloat(revenueAndSalesStats?.revenue_growth_percentage ?? "0") >= 25
                                ? "badge-soft-warning"
                                : "badge-soft-danger"
                            }`}
                        >
                          <i className="ti ti-chart-line me-1" />
                          {revenueAndSalesStats?.revenue_growth_percentage ?? "--"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Target Revenue */}
                <div className="col-xxl-3 col-xl-3 col-md-6 d-flex flex-column">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <p className="mb-2">Target Revenue</p>
                      <div className="d-flex align-items-end justify-content-between">
                        <h4>
                          ₹{revenueAndSalesStats?.target_revenue ?? "--"}
                        </h4>

                        {/* <span
                        className={`badge ${Number(revenueAndSalesStats?.revenue_growth_percentage) >= 0
                          ? "badge-soft-success"
                          : "badge-soft-danger"
                          }`}
                      >
                        <i className="ti ti-chart-line me-1" />
                        {revenueAndSalesStats?.revenue_growth_percentage ?? "--"}%
                      </span> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-xxl-6 col-xl-6  d-flex">
                {SalesRankLoading ? (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <LogoSpinnerInline />
                  </div>
                ) : (
                  <div className="card flex-fill" style={{ height: "420px" }}>
                    {/* ---------- HEADER ---------- */}
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">

                      {/* LEFT SIDE */}
                      <h4 className="card-title mb-3">
                        {"Branch Sales"}
                      </h4>

                      {/* RIGHT SIDE */}
                      <div className="d-flex align-items-center flex-wrap">

                        <div className="me-3 mb-3">
                          <Select
                            showSearch
                            placeholder="Select Zone"
                            value={selectedZone}
                            allowClear
                            onChange={(value) => setSelectedZone(value)}
                            style={{ width: 150 }}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            options={zones.map(zone => ({
                              value: zone.zone_id,
                              label: zone.name,
                            }))}
                          />
                        </div>

                        <div className="me-3 mb-3">
                          <Select
                            showSearch
                            placeholder="Select Rank Group"
                            value={selectedGroup}
                            onChange={(value) => setSelectedGroup(value)}
                            style={{ width: 150 }}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            options={rankGroups.map(group => ({
                              value: group.id,
                              label: group.name,
                            }))}
                          />
                        </div>

                        {checkPermission("export_branch_sales", "wizklubbranchsalesranking") && (
                          <div className="pe-1 mb-3" onClick={handleExportClick}>
                            <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip id="tooltip-top">Export</Tooltip>}
                            >
                              <button
                                type="button"
                                className="btn btn-outline-light bg-white btn-icon me-1"
                              >
                                <i className="ti ti-printer" />
                              </button>
                            </OverlayTrigger>
                          </div>
                        )}

                      </div>
                    </div>

                    {/* ---------- BODY (SCROLLABLE) ---------- */}
                    <div
                      className="card-body px-0 m-1"
                      style={{
                        height: "calc(420px - 80px)", // header height adjustment
                        overflowY: "auto",
                      }}
                    >
                      <div className="custom-datatable-filter table-responsive">
                        <table className="table mb-0">
                          <thead className="thead-light">
                            <tr>
                              <th>Branch Name</th>
                              <th>Sales</th>
                              <th>Strength</th>
                            </tr>
                          </thead>

                          <tbody>
                            {salesRank?.branch_wise_sale_details?.length ? (
                              salesRank.branch_wise_sale_details.map(
                                (branch: BranchSalesRanking) => (
                                  <tr key={branch.id}>
                                    <td>{branch.branch_name}</td>
                                    <td>{branch.sales}</td>
                                    <td>{branch.strength}</td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td colSpan={3} className="text-center">
                                  No data available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="col-xxl-6 col-xl-6 d-flex">
                {teamRankLoading ? (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <LogoSpinnerInline />
                  </div>
                ) : (
                  <div className="card flex-fill" style={{ height: "420px" }}>
                    {/* ---------- HEADER ---------- */}
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                      <h4 className="card-title mb-3">
                        {"Team Sales"}
                      </h4>

                      <div className="d-flex align-items-center">
                        <div className="me-3 mb-3">
                          <Select
                            showSearch

                            placeholder="Select Rank Group"
                            value={selectedTeamGroup}
                            onChange={(value) => setSelectedTeamGroup(value)}
                            style={{ width: 150, borderTopColor: '#fff', borderLeftColor: '#fff', borderRightColor: '#fff' }}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            options={teamRankGroups.map(group => ({
                              value: group.id,
                              label: group.name,
                            }))}
                          />
                        </div>
                      </div>
                    </div>

                    {/* ---------- BODY (SCROLLABLE) ---------- */}
                    <div
                      className="card-body px-0 m-1"
                      style={{
                        height: "calc(420px - 80px)", // header height adjustment
                        overflowY: "auto",
                      }}
                    >
                      <div className="custom-datatable-filter table-responsive">
                        <table className="table mb-0">
                          <thead className="thead-light">
                            <tr>
                              <th>Agent</th>
                              <th>Sales</th>
                              {/* <th>Strength</th> */}
                            </tr>
                          </thead>

                          <tbody>
                            {teamRank?.members?.length ? (
                              teamRank.members.map(
                                (branch: TeamsRankingMembers) => (
                                  <tr key={branch.id}>
                                    <td>{branch.username}</td>
                                    <td>{branch.no_of_sales}</td>
                                    {/* <td>{branch.strength}</td> */}
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td colSpan={3} className="text-center">
                                  No data available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {/* <div className="col-xxl-4 col-xl-4 d-flex">
                {followUpSalesLoading ? (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <LogoSpinnerInline />
                  </div>
                ) : (
                  <div className="card flex-fill" style={{ height: "420px" }}>
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                      <h4 className="card-title mb-3">Follow-Up Sales Details</h4>
                    </div>        
                    <div
                      className="card-body px-0 m-1"
                      style={{
                        height: "calc(420px - 80px)",
                        overflowY: "auto"
                      }}
                    >
                      <div className="custom-datatable-filter table-responsive">
                        <table className="table mb-0">
                          <thead className="thead-light">
                            <tr>
                              <th>Period</th>
                              {followUpSales.columns.map((col) => (
                                <th key={col}>
                                  {col
                                    .replaceAll("_", " ")
                                    .replace(/\b\w/g, (c) => c.toUpperCase())}
                                </th>
                              ))}
                            </tr>
                          </thead>

                          <tbody>
                            {followUpSales.rows.length > 0 ? (
                              followUpSales.rows.map((row, index) => (
                                <tr key={index}>
                                  <td className="text-capitalize">{row.period}</td>
                                  {followUpSales.columns.map((col: string) => (
                                    <td key={col}>
                                      {col === "percentage"
                                        ? `${row[col as keyof FollowUpRow]}%`
                                        : row[col as keyof FollowUpRow]}
                                    </td>
                                  ))}
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={followUpSales.columns.length + 1} className="text-center">
                                  No data available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
              </div> */}
              <div className="col-xxl-6 col-xl-6 d-flex">
                {currentYearBranchTableLoading ? (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <LogoSpinnerInline />
                  </div>
                ) : (
                  <div className="card flex-fill" style={{ height: "460px", overflowY: "auto", }}>
                    {/* ---------- HEADER ---------- */}
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                      <h4 className="card-title mb-3">
                        {"Sales"}
                      </h4>

                      <div className="d-flex align-items-center">
                        <div className="me-3 mb-3">
                          <Select
                            showSearch
                            placeholder="Select Rank Group"
                            value={selectedCurrentYearBranch}
                            onChange={(value) => setSelectedCurrentYearBranch(value)}
                            style={{ width: 150, borderTopColor: '#fff', borderLeftColor: '#fff', borderRightColor: '#fff' }}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            options={branchDropDropwn.map(group => ({
                              value: group.branch_id,
                              label: group.name,
                            }))}
                          />
                        </div>
                      </div>
                    </div>

                    {/* ---------- BODY (SCROLLABLE) ---------- */}
                    <div className="card-body">
                      <ul className="list-group">
                        {currrentYearBranchClassWise?.class_wise_sales?.map((item, index) => {
                          const percentage =
                            item.strength > 0
                              ? Math.min((item.total_sales / item.strength) * 100, 100)
                              : 0;

                          const barColor =
                            percentage >= 75
                              ? "bg-success"
                              : percentage >= 50
                                ? "bg-info"
                                : percentage >= 25
                                  ? "bg-warning"
                                  : "bg-danger";
                          return (
                            <li className="list-group-item" key={item.class_id}>
                              <div className="row align-items-center">
                                <div className="col-sm-4">
                                  <p className="text-dark mb-0">
                                    {item.class_name}
                                    <small className="text-muted">
                                      {" "}({item.total_sales} / {item.strength})
                                    </small>
                                  </p>
                                </div>

                                <div className="col-sm-8 d-flex align-items-center gap-2">
                                  <div className="progress flex-grow-1" style={{ height: "8px" }}>
                                    <div
                                      className={`progress-bar ${barColor} rounded`}
                                      role="progressbar"
                                      style={{ width: `${percentage}%` }}
                                      aria-valuenow={percentage}
                                      aria-valuemin={0}
                                      aria-valuemax={100}
                                    />
                                  </div>

                                  {/* Percentage text */}
                                  <span className="small fw-bold text-dark">
                                    {percentage.toFixed(0)}%
                                  </span>
                                </div>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </div>

                  </div>
                )}
              </div>
              <div className="col-xxl-6 col-xl-6 d-flex">
                {lastYearBranchTableLoading ? (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <LogoSpinnerInline />
                  </div>
                ) : (
                  <div className="card flex-fill" style={{ height: "460px", overflowY: "auto", }}>
                    {/* ---------- HEADER ---------- */}
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                      <h4 className="card-title mb-3">
                        {"Renewal Sales"}
                      </h4>


                      <div className="d-flex align-items-center">
                        <div className="me-3 mb-3">
                          <Select
                            showSearch

                            placeholder="Select Rank Group"
                            value={selectedCurrentYearBranch}
                            onChange={(value) => setSelectedCurrentYearBranch(value)}
                            style={{ width: 150, borderTopColor: '#fff', borderLeftColor: '#fff', borderRightColor: '#fff' }}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            options={branchDropDropwn.map(group => ({
                              value: group.branch_id,
                              label: group.name,
                            }))}
                          />
                        </div>
                      </div>
                    </div>

                    {/* ---------- BODY (SCROLLABLE) ---------- */}
                    <div className="card-body">
                      <ul className="list-group">
                        {lastYearBranchClassWise?.class_wise_sales?.map((item, index) => {
                          const percentage =
                            item.last_year_sales > 0
                              ? Math.min((item.renewal_sales / item.last_year_sales) * 100, 100)
                              : 0;

                          const barColor =
                            percentage >= 75
                              ? "bg-success"
                              : percentage >= 50
                                ? "bg-info"
                                : percentage >= 25
                                  ? "bg-warning"
                                  : "bg-danger";


                          return (
                            <li className="list-group-item" key={item.class_id}>
                              <div className="row align-items-center">
                                <div className="col-sm-4">
                                  <p className="text-dark mb-0">
                                    {item.class_name}
                                    <small className="text-muted">
                                      {" "}({item.renewal_sales} / {item.last_year_sales})
                                    </small>
                                  </p>
                                </div>

                                <div className="col-sm-8 d-flex align-items-center gap-2">
                                  <div className="progress flex-grow-1" style={{ height: "8px" }}>
                                    <div
                                      className={`progress-bar ${barColor} rounded`}
                                      role="progressbar"
                                      style={{ width: `${percentage}%` }}
                                      aria-valuenow={percentage}
                                      aria-valuemin={0}
                                      aria-valuemax={100}
                                    />
                                  </div>

                                  {/* Percentage */}
                                  <span className="small fw-bold text-dark">
                                    {percentage.toFixed(0)}%
                                  </span>
                                </div>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                )}
              </div>

            </div>

          </>
          {/* Floating Toggle */}
          <div
            style={{
              position: "fixed",
              bottom: "10px",
              right: "4px",
              zIndex: 2000,
            }}
          >
            <img
              src="/assets/img/podium_11543322.png"
              alt="Leaderboard"
              title="Leaderboard"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRight"
              aria-controls="offcanvasRight"
              style={{
                cursor: "pointer",
                width: "48px",
                height: "48px",
              }}
            />
          </div>

          {/* Offcanvas */}

        </div>

      </div >
      <div
        className="modal fade"
        id="exampleModalScrollable3"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">

            <div className="modal-header">
              <h4 className="modal-title">
                {selectedAttendanceType === 'present' ? 'Present Agents' : 'Absent Agents'}
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>

            {/* 👇 KEY FIX HERE */}
            <div className="modal-body" style={{ maxHeight: "60vh", overflowY: "auto" }}>

              {attendanceLoading ? (
                <div className="text-center py-3">Loading...</div>
              ) : attendanceList.length === 0 ? (
                <div className="text-center text-muted">No Data Found</div>
              ) : (
                <div className="list-group">
                  {attendanceList.map((item) => (
                    <div
                      key={item.id}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <h6 className="mb-0">{item.agent_username}</h6>
                        <small className="text-muted">{item.date_display}</small>
                      </div>

                      <span
                        className={`badge ${item.is_present ? 'bg-success' : 'bg-danger'
                          }`}
                      >
                        {item.is_present ? 'Present' : 'Absent'}
                      </span>
                    </div>
                  ))}
                </div>
              )}

            </div>
          </div>
        </div>
      </div>
      <AdminDashboardModal />
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
        style={{
          height: "100vh",
          width: "380px",
          borderLeft: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        <div
          className="offcanvas-header"
          style={{
            borderBottom: "1px solid rgba(255,255,255,0.08)",
            background: "#0f0c29",
            color: "white",
          }}
        >
          <h5 id="offcanvasRightLabel" style={{ margin: 0, color: "white" }}>Leader Board</h5>
          <button
            type="button"
            className="btn-close btn-close-white"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>{" "}

        <div
          className="offcanvas-body"
          style={{
            padding: 0,
            height: "calc(100vh - 56px)", // full remaining height
            overflowY: "auto",
            background: "linear-gradient(180deg,#0f0c29,#1b153a)",
          }}
        >
          <Leaderboard />
        </div>{" "}
      </div>{" "}
    </>
  );
};

export default AdminDashboard1;